{
  "common": {
    "actions": {
      "add": "އިތުރުކުރޭ",
      "cancel": "ކެންސަލްކުރޭ",
      "clear": "ސާފުކުރޭ",
      "clearFilters": "ފިލްޓަރތައް ސާފުކުރޭ",
      "close": "ބަންދުކުރޭ",
      "copy": "ކޮޕީކުރޭ",
      "copyAll": "ކޮޕީކުރޭ ހުރިހާ",
      "dismiss": "ޑިސްމިސްސް",
      "edit": "އެޑިޓްކުރޭ",
      "filter": "ފިލްޓަރ",
      "next": "ދެން",
      "previous": "ކުރީގެ",
      "retry": "އަލުން މަސައްކަތްކުރޭ",
      "save": "ރައްކާކުރޭ",
      "saveChanges": "ބަދަލުތައް ރައްކާކުރޭ",
      "search": "ހޯދާ",
      "signIn": "ސައިން އިން",
      "signOut": "ސައިން އައުޓް",
      "tryAgain": "އަލުން މަސައްކަތްކުރޭ"
    },
    "labels": {
      "account": "އަކްކައުންޓް",
      "actions": "އަމަލުތައް",
      "administrator": "އެޑްމިނިސްޓްރޭޓަރު",
      "created": "އުފެއްދިއްޖެ",
      "currency": "ފައިސާ",
      "description": "ތަފްޞީލު",
      "email": "އީމެއިލް",
      "lastSignIn": "އެންމެފަހު ސައިން އިން",
      "loading": "ލޯޑްވަނީ",
      "mfa": "އެމްއެފްއޭ",
      "name": "ނަން",
      "none": "އެއްވެސްއެއްޗެއްނެތް",
      "password": "ޕާސްވޯޑް",
      "plan": "ޕްލޭން",
      "reason": "ސަބަބު",
      "region": "ސަރަހައްދު",
      "role": "ރޯލް",
      "slug": "ސްލުގް",
      "status": "ސްޓޭޓަސް",
      "timezone": "ޓައިމްޒޯން",
      "unlimited": "ލިމިޓެއް ނެތް",
      "user": "ބޭނުންކުރާ ފަރާތް"
    },
    "mfa": {
      "enrolled": "އެންރޯލްކުރެވިފައި",
      "notEnrolled": "އެންރޯލްކުރެވިފައި ނުވޭ"
    },
    "roles": {
      "billing": "ބިލިންގ",
      "owner": "އޯނަރު",
      "support": "ސަޕޯޓް"
    },
    "userStatus": {
      "active": "ހަރަކާތްތެރި",
      "disabled": "ހުއްޓާލެވިފައި",
      "invited": "ދައުވަތު ދެވިފައި",
      "locked": "ތަޅުލެވިފައި"
    },
    "validation": {
      "emailInvalid": "ލިޔެލާ ސައްހަ އީމެއިލް އެޑްރެސް.",
      "emailRequired": "އީމެއިލް އީ ލާޒިމު.",
      "nameRequired": "ނަން އީ ލާޒިމު.",
      "passwordRequired": "ޕާސްވޯޑް އީ ލާޒިމު.",
      "reasonMinLength": "{label} ލާޒިމު ވުން ގައި މަދުވެގެން {min} އަކުރު — އެ އީ ރެކޯޑްކުރެވިފައި މަތީގައި އޮޑިޓް ރެކޯޑް.",
      "reasonPlaceholder": "ގައި މަދުވެގެން {min} އަކުރު",
      "reasonRequired": "{label} އީ ލާޒިމު."
    }
  },
  "ui": {
    "button": {
      "working": "މަސައްކަތްކުރަނީ"
    },
    "field": {
      "optional": "އޮޕްޓިއޮނަލް",
      "required": "(ލާޒިމު)"
    },
    "money": {
      "negative": "ނެގަޓިވް {amount}"
    },
    "select": {
      "clear": "އެއްވެސްއެއްޗެއްނެތް",
      "placeholder": "ހޮވާ…"
    },
    "pagination": {
      "empty": "ނެތް ރެކޯޑްތައް",
      "label": "ޞަފްޙާކުރުން",
      "nextPage": "ދެން ޞަފްޙާ",
      "perPage": "{size} ކޮންމެ ޞަފްޙާ",
      "previousPage": "ކުރީގެ ޞަފްޙާ",
      "showing": "ދައްކަނީ {range}",
      "showingOfTotal": "ދައްކަނީ {range} ގެ {total}"
    },
    "table": {
      "chooseColumns": "ހޮވާ ކޮލަމްތައް",
      "columns": "ކޮލަމްތައް",
      "emptyTitle": "އެއްވެސްއެއްޗެއްނެތް އަށް ދައްކާ އަދި",
      "filteredDescription": "މަސައްކަތްކުރޭ ފުޅާކުރުން ތާރީޚް ރޭންޖް ނުވަތަ ސާފުކުރުން ފިލްޓަރ ޗިޕް.",
      "filteredTitle": "ނެތް ރެކޯޑްތައް ދިމާވުން މިތަކެތި ފިލްޓަރތައް",
      "recordCountOne": "{count} ރެކޯޑް",
      "recordCountOther": "{count} ރެކޯޑްތައް",
      "selectAllRows": "ހޮވާ ހުރިހާ ސަފުތައް މަތީގައި މި ޞަފްޙާ",
      "selectRow": "ހޮވާ ސަފު {index}",
      "visibleColumns": "ފެންނަ ކޮލަމްތައް"
    },
    "panel": {
      "emptyTitle": "އެއްވެސްއެއްޗެއްނެތް މިތާ އަދި"
    }
  },
  "errors": {
    "generic": "ކޮންމެވެސްއެއްޗެއް ދިޔަ ގޯސް.",
    "loadTitle": "އެ ކުރި ނޫން ލޯޑް",
    "trace": "ޓްރޭސް {id}",
    "slugTaken": "އެ ސްލުގް އީ ކުރިންވެސް ޓަކެން. ހޮވާ އިތުރު.",
    "slugTakenShort": "އެ ސްލުގް އީ ކުރިންވެސް ޓަކެން.",
    "slugRejected": " ސާވަރ ބޭރުކުރެވިއްޖެ މި ސްލުގް: އެ ލާޒިމު ވުން 3–30 އަކުރު ގެ ކުދި އަކުރު އަކުރުތައް, ޢަދަދުތައް ނުވަތަ އަންޑަރސްކޯރތައް.",
    "codes": {
      "ERR_BUDGET_EXCEEDED": "މި ވީސް ނަގާ ބަޖެޓް ފަހަނައަޅާ އޭގެ ލިބެންހުރި ބެލެންސް.",
      "ERR_CONFLICT": "ކޮންމެވެސްމީހެއް އެހެން ބަދަލުކުރެވިއްޖެ މި ފުރަތަމަ. އަލުންލޯޑްކުރޭ އަދި އަލުން މަސައްކަތްކުރޭ.",
      "ERR_CREDIT_LIMIT": "މި ކަސްޓަމަރު އީ މަތިން އެ ފަރާތްތަކުގެ ކްރެޑިޓް ލިމިޓް.",
      "ERR_DUPLICATE_INVOICE": " އިންވޮއިސް އާއެކު މި ނަންބަރު ކުރިންވެސް އެބައޮތް ށްޓަކައި މި ވިއްކާ ފަރާތް.",
      "ERR_FORBIDDEN": "ތިޔަ ފަރާތުގެ ރޯލް ކުރޭ ނޫން ހުއްދަދޭ މި އަމަލު.",
      "ERR_IDEMPOTENCY_MISMATCH": "މި އެދުން ވި ކުރިންވެސް ފޮނުވިއްޖެ އާއެކު ތަފާތު މައުލޫމާތު. އަލުންލޯޑްކުރޭ އަދި އަލުން މަސައްކަތްކުރޭ.",
      "ERR_ILLEGAL_TRANSITION": "އެ ސްޓޭޓަސް ބަދަލު އީ ނޫން ހުއްދަ އިން ކޮންތާކު މި ރެކޯޑް އީ މިހާރު.",
      "ERR_INTERNAL": " ސާވަރ ކުރެވުނު ނޫން ފުރިހަމަ މި. އެ އެބަހުރި ވެފައި ލޮގްކުރެވިއްޖެ — އަލުން މަސައްކަތްކުރޭ, އަދި ބަޔާންކުރޭ ޓްރޭސް id އެއްވެސްހާލެއްގައި އެ ބަހައްޓާ ނާކާމިޔާބުވުން.",
      "ERR_MFA_REQUIRED": "މަލްޓި-ފެކްޓަރ އޮތެންޓިކޭޝަން އީ ލާޒިމު ކުރިން ތިޔަ ފަރާތް ކުރެވޭނެ ކުރޭ މި.",
      "ERR_NOT_FOUND": "އެ ރެކޯޑް ނެތް އިތުރަށް އެބައޮތް.",
      "ERR_PERIOD_CLOSED": " އެކައުންޓިންގ މުއްދަތު އީ ބަންދުކުރެވިފައި, އެހެންކަމުން އެއްވެސްއެއްޗެއްނެތް ކުރެވޭނެ ވުން ޕޯސްޓްކުރެވިފައި ތެރެއަށް އެ.",
      "ERR_RATE_LIMITED": "މާ ގިނަ އެދުންތައް. މަޑުކުރޭ ވަގުތުކޮޅެއް އަދި އަލުން މަސައްކަތްކުރޭ.",
      "ERR_ROW_VERSION": "މި ރެކޯޑް ބަދަލުކުރެވިއްޖެ ދަނޑިވަޅުގައި ތިޔަ ފަރާތް ވި އެޑިޓްކުރުން އެ. އަލުންލޯޑްކުރޭ އެ އަދި އަލުން ބޭނުންކުރޭ ތިޔަ ފަރާތުގެ ބަދަލުތައް.",
      "ERR_SOD_VIOLATION": "ވަކިކުރުން ގެ ޒިންމާތައް: އެއް މީހާ ނުކުރެވޭނެ ދެބައި އުފުލާ އަދި ފާސްކުރޭ މި.",
      "ERR_STEP_UP_REQUIRED": "ޔަގީންކުރޭ ތިޔަ ފަރާތުގެ ވަނަވަރު އާއެކު ތިޔަ ފަރާތުގެ އޮތެންޓިކޭޓަރު ކުރިން ޑޮއިންގް މި.",
      "ERR_TENANT_SUSPENDED": "މި ޓެނަންޓް އީ ސަސްޕެންޑްކުރެވިފައި. އަލުން ހަރަކާތްތެރިކުރޭ އެ ކުރިން މަކިންގް ބަދަލުތައް.",
      "ERR_UNAUTHENTICATED": "ތިޔަ ފަރާތުގެ ސެޝަން އެބަހުރި ނިމިއްޖެ. ސައިން އިން އަލުން.",
      "ERR_PACK_IMMUTABLE": "މި ޕެކް ޕަބްލިޝްކޮށްފައިވާތީ، އޭގެ ކޮންޓެންޓް ދެން ބަދަލެއް ނުކުރެވޭނެއެވެ. އޭގެ މައްޗަށް އައު ވަރޝަނެއް ޑްރާފްޓްކުރައްވާ.",
      "ERR_PACK_DUAL_CONTROL": "ޕެކް ހުށަހެޅި އޮޕަރޭޓަރަށް އެ ޕެކް ޕަބްލިޝެއް ނުކުރެވޭނެއެވެ. ދެވަނަ އޯނަރަކު ޖެހޭނެއެވެ.",
      "ERR_PACK_VALIDATION": "ޕޭލޯޑުގައި ހައްލުނުވާ ސައްހަކުރުމުގެ މައްސަލަތަކެއް ހުރުމުން، ޕަބްލިޝެއް ނުކުރެވޭނެއެވެ.",
      "ERR_PACK_NOT_SUBMITTED": "މި ޕެކް އަދި ޕަބްލިޝްކުރަން ހުށަހަޅާފައެއް ނެތެވެ.",
      "ERR_TAX_PACK_NOT_ACTIVATED": "މި ޓެނަންޓް އެ ގައުމުގެ ޕެކެއް ފައްޓާފައެއް ނެތެވެ.",
      "ERR_TAX_PACK_NO_ENTITY": "އެ ގައުމުގައި އަދި ކުންފުންޏެއް ނެތް، އެހެންވީމަ މި ޕެކް ހިންގާނެ ތަނެއް ނެތް.",
      "ERR_TAX_PACK_NOT_PUBLISHED": "އެ ގައުމަކަށް އަދި ޕަބްލިޝްކުރި ޓެކްސް ޕެކެއް ނެތް.",
      "ERR_TAX_PACK_ALREADY_ACTIVATED": "މި ޓެނަންޓަށް އެ ގައުމުގެ ޓެކްސް ޕެކް މިހާރުވެސް ފައްޓާފައިވެއެވެ."
    }
  },
  "routes": {
    "appName": "erpx ޕްލެޓްފޯމް އެޑްމިން",
    "documentTitle": "{title} · erpx އެޑްމިން",
    "login": "ސައިން އިން",
    "mfaEnrol": "ސެޓް މައްޗަށް އޮތެންޓިކޭޝަން",
    "dashboard": "ޕްލެޓްފޯމް",
    "tenants": "ޓެނަންޓްތައް",
    "tenantCreate": "ޓެނަންޓެއް ގުޅުވާލާ",
    "tenantCreateCrumb": "ގުޅުވާލާ",
    "tenantDetail": "ޓެނަންޓް",
    "plans": "ޕްލޭންތައް",
    "admins": "ޕްލެޓްފޯމް އެޑްމިންތައް",
    "notFound": "ނުފެނުނު",
    "billing": "ބިލިންގ",
    "subscriptions": "ސަބްސްކްރިޕްޝަންތައް",
    "subscription": "ސުބްސްކްރިޕްޓިއޮން",
    "invoices": "އިންވޮއިކެސް",
    "invoice": "އިންވޮއިސް",
    "payments": "ޕޭމެންޓްސް",
    "forgotPassword": "ރީސެޓް ޕާސްވޯޑް",
    "resetPassword": "ހޮވާ އާ ޕާސްވޯޑް",
    "acceptInvite": "ގަބޫލުކުރޭ އިންވިޓަޓިއޮން"
  },
  "nav": {
    "primaryLabel": "މައިގަނޑު",
    "platform": {
      "label": "ޕްލެޓްފޯމް",
      "description": "ޓެނަންޓް އަދަދުތައް, ސައިންއަޕްތައް, ދުޅަހެޔޮކަން"
    },
    "tenants": {
      "label": "ޓެނަންޓްތައް",
      "description": "ގުޅުވާލުން, ލައިފްސައިކަލް, ސަޕޯޓް"
    },
    "plans": {
      "label": "ޕްލޭންތައް",
      "description": "ހައްގުކުރުންތައް އަދި އަގުތައް"
    },
    "billing": {
      "label": "ބިލިންގ",
      "description": "ސަބްސްކްރިޕްޝަންތައް, އިންވޮއިކެސް, ޕޭމެންޓްސް"
    },
    "admins": {
      "label": "ޕްލެޓްފޯމް އެޑްމިންތައް",
      "description": "އޮޕަރޭޓަރުން އަދި އެ ފަރާތްތަކުގެ ރޯލްތައް"
    },
    "group": {
      "localization": "ލޯކަލައިޒޭޝަން"
    },
    "geography": {
      "label": "ޖިއޮގްރަފީ",
      "description": "ގައުމުތައް، ސަރަހައްދުތައް، ރަށްތައް"
    },
    "taxPacks": {
      "label": "ޓެކްސް ޕެކްތައް",
      "description": "ރޭޓްތަކާއި ގަވާއިދުތައް، ޑްރާފްޓުން ޕަބްލިޝްއަށް"
    },
    "taxPackAdoption": {
      "label": "ޕެކް ބޭނުންކުރުން",
      "description": "ކޮން ޓެނަންޓެއް ކޮން ވަރޝަނެއްގައިކަން"
    },
    "signedInAs": "ސައިން ވެފައި ގައި ގޮތުގައި {role}.",
    "roleNote": {
      "billing": "ސަޕޯޓް އެހީތެރިކަން އަދި ޓެނަންޓް ލައިފްސައިކަލް އަމަލުތައް ވަނީ ބަންދުކުރެވިފައި އަށް މި ރޯލް.",
      "support": "ޕްލޭން އަދި އެޑްމިނިސްޓްރޭޓަރު ބަދަލުތައް ވަނީ ހަމައެކަނި އޯނަރަށް."
    }
  },
  "shell": {
    "skipToContent": "ފުންމާލާ އަށް މައުލޫމާތު",
    "brandSuffix": "ޕްލެޓްފޯމް އެޑްމިން",
    "collapseNav": "ކުޑަކުރޭ ނެވިގޭޝަން",
    "expandNav": "ބޮޑުކުރޭ ނެވިގޭޝަން",
    "searchButton": "ހޯދާ ޓެނަންޓްތައް, ޕްލޭންތައް އަދި އަމަލުތައް",
    "footerHint": "ފިއްތާ {key} ށްޓަކައި ކީބޯޑް ޝޯޓްކަޓްތައް",
    "breadcrumbLabel": "ބްރެޑްކްރަމް",
    "breadcrumbRoot": "ޕްލެޓްފޯމް",
    "menu": {
      "shortcuts": "ކީބޯޑް ޝޯޓްކަޓްތައް",
      "signOut": "ސައިން އައުޓް"
    },
    "theme": {
      "toDark": "ބަދަލުކުރޭ އަށް އަނދިރި ތީމް",
      "toLight": "ބަދަލުކުރޭ އަށް އަލި ތީމް"
    },
    "locale": {
      "label": "ބަސް",
      "trigger": "ބަދަލު ބަސް",
      "current": "މިހާރުގެ ބަސް: {language}"
    },
    "shortcuts": {
      "title": "ކީބޯޑް ޝޯޓްކަޓްތައް",
      "description": "ހުރިހާއެއްޗެއް މިހާރު ބަނދެފައި މަތީގައި މި ސްކްރީން.",
      "groups": {
        "approvals": "ފާސްކުރުންތައް",
        "document": "ލިޔެކިޔުންތައް",
        "global": "ކޮންމެ ތާކު",
        "grid": "ގްރިޑްތައް",
        "list": "ލިސްޓްތައް",
        "navigation": "ނެވިގޭޝަން"
      },
      "commandPalette": "ހުޅުވާ ކޮމާންޑް ޕެލެޓް",
      "cheatSheet": "ދައްކާ ކީބޯޑް ޝޯޓްކަޓްތައް",
      "quickCreate": "ގުޅުވާލާ އާ ޓެނަންޓް"
    },
    "copy": {
      "toastTitle": "{what} ކޮޕީކުރެވިއްޖެ",
      "toastBody": "އެ އީ މަތީގައި ތިޔަ ފަރާތުގެ ކްލިޕްބޯޑް.",
      "failedTitle": "ކުރެވުނު ނޫން ކޮޕީކުރޭ އަމިއްލައަށް",
      "failedBody": "ހޮވާ ލިޔުން އަދި ކޮޕީކުރޭ އެ އާއެކު ތިޔަ ފަރާތުގެ ކީބޯޑް.",
      "defaultWhat": "އަގު",
      "buttonLabel": "ކޮޕީކުރޭ {what} އަށް ކްލިޕްބޯޑް",
      "copied": "ކޮޕީކުރެވިއްޖެ"
    }
  },
  "palette": {
    "title": "ކޮމާންޑް ޕެލެޓް",
    "listLabel": "ކޮމާންޑްތައް",
    "placeholder": "ހޯދާ ޓެނަންޓްތައް, ސްކްރީންތައް އަދި އަމަލުތައް…",
    "empty": "ނެތް ދިމާވާ ކޮމާންޑް",
    "hint": {
      "close": "އަށް ބަންދުކުރޭ",
      "escKey": "އެސްކް",
      "navigate": "އަށް ނެވިގޭޓްކުރޭ",
      "run": "އަށް ހިނގާ"
    },
    "groups": {
      "create": "އުފައްދާ",
      "goTo": "ދޭ އަށް",
      "preferences": "އިސްކަންދޭ ގޮތްތައް",
      "tenants": "ޓެނަންޓްތައް"
    },
    "items": {
      "dashboard": "ޕްލެޓްފޯމް ޑޭޝްބޯޑް",
      "tenants": "ޓެނަންޓްތައް",
      "plans": "ޕްލޭންތައް",
      "admins": "ޕްލެޓްފޯމް އެޑްމިންތައް",
      "onboard": "ޓެނަންޓެއް ގުޅުވާލާ",
      "onboardHint": "ހިންގާ ޕްރޮވިޜަންކުރުން ސާގާ އާއެކު ލައިވް ފިޔަވަޅު ކުރިއެރުން",
      "themeToDark": "ބަދަލުކުރޭ އަށް އަނދިރި ތީމް",
      "themeToLight": "ބަދަލުކުރޭ އަށް އަލި ތީމް",
      "localeSwitch": "ބަދަލުކުރޭ ބަސް އަށް {language}"
    }
  },
  "auth": {
    "login": {
      "title": "ޕްލެޓްފޯމް އެޑްމިން",
      "intro": "އޮޕަރޭޓަރު އެކްސެސް އަށް ކޮންމެ ޓެނަންޓް މަތީގައި މި ޑިޕްލޯއިމަންޓް. މަލްޓި-ފެކްޓަރ އޮތެންޓިކޭޝަން އީ ލާޒިމު މަތީގައި މި ރެލްމް.",
      "emailLabel": "އީމެއިލް",
      "passwordLabel": "ޕާސްވޯޑް",
      "codeLabel": "އޮތެންޓިކޭޝަން ކޯޑް",
      "codeHint": "ހަޔެއް ޢަދަދުތައް އިން ތިޔަ ފަރާތުގެ އޮތެންޓިކޭޓަރު އެޕް.",
      "submit": "ސައިން އިން",
      "submitWithCode": "ބަލައިގަނޭ އަދި ސައިން އިން",
      "mfaPrompt": "ލިޔެލާ ހަ ޢަދަދުގެ ކޯޑް އިން ތިޔަ ފަރާތުގެ އޮތެންޓިކޭޓަރު އެޕް.",
      "failed": "ސައިން އިން ނާކާމިޔާބު. ބަލާ ތިޔަ ފަރާތުގެ ތަފްޞީލު އަދި އަލުން މަސައްކަތްކުރޭ.",
      "forgot": "އަހަރެން އެބަހުރި ފޮރްގޮޓްޓެން މްޔް ޕާސްވޯޑް"
    },
    "mfa": {
      "title": "ސެޓް މައްޗަށް ދެ-ފެކްޓަރ އޮތެންޓިކޭޝަން",
      "intro": "މި ކޮންސޯލް ބޭނުންވޭ އޮތެންޓިކޭޓަރު މަތީގައި ކޮންމެ އަކްކައުންޓް. ވަންދެން މި އީ ނިމިއްޖެ ރެސްޓް ގެ ޕްލެޓްފޯމް އެޑްމިން އީ ބަންދުކުރެވިފައި އަށް ތިޔަ ފަރާތް — އެ އީ ސާވަރުގެ ގަވާއިދު, ނޫން މި ސްކްރީނުގެ.",
      "scanTitle": "ސްކޭންކުރޭ މި ކޯޑް",
      "scanStep": "ހުޅުވާ ތިޔަ ފަރާތުގެ އޮތެންޓިކޭޓަރު އެޕް އަދި ސްކޭންކުރޭ ކޯޑް.",
      "confirmStep": "ލިޔެލާ ހަޔެއް ޢަދަދުތައް އެ ދައްކާ އަށް ޔަގީންކުރޭ ޕެއަރކުރުން.",
      "manualIntro": "ނުކުރެވޭނެ ސްކޭންކުރޭ? ލިޔެލާ މި ތަޅުދަނޑި އަތުން:",
      "setupKeyWhat": "ސެޓަޕް ތަޅުދަނޑި",
      "codeLabel": "އޮތެންޓިކޭޝަން ކޯޑް",
      "codeInvalid": "ލިޔެލާ ހަޔެއް ޢަދަދުތައް ދެއްކިފައި ގައި ތިޔަ ފަރާތުގެ އޮތެންޓިކޭޓަރު އެޕް.",
      "codeRejected": "އެ ކޯޑް ކުރި ނޫން ބަލައިގަނޭ. މަސައްކަތްކުރޭ ދެން އެއް.",
      "confirm": "ޔަގީންކުރޭ",
      "enrolFailed": "އެންރޯލްކުރުން ކުރެވުނު ނޫން ފަށާ",
      "qrLabel": "އޮތެންޓިކޭޓަރު އެންރޯލްކުރުން QR ކޯޑް",
      "recovery": {
        "title": "ރައްކާކުރޭ ތިޔަ ފަރާތުގެ ރިކަވަރީ ކޯޑްތައް",
        "body": "ކޮންމެ ކޯޑް ސައިން ކުރުވާ ތިޔަ ފަރާތް ގައި އެއްފަހަރު އެއްވެސްހާލެއްގައި ތިޔަ ފަރާތް ގެއްލުން ތިޔަ ފަރާތުގެ އޮތެންޓިކޭޓަރު.",
        "onlyOnce": "އެ ފަރާތްތައް ވަނީ ރައްކާކުރެވިފައި ހަމައެކަނި ގޮތުގައި ހޭޝްތައް, އެހެންކަމުން މި އީ ހަމައެކަނި ވަގުތު އެ ފަރާތްތައް ކުރެވޭނެ ވުން ދެއްކިފައި.",
        "keepSafe": "ބަހައްޓާ އެ ފަރާތްތަކަށް ކޮންމެވެސް ތާކު ތިޔަ ފަރާތް ވީސް ބަހައްޓާ ޕާސްވޯޑް.",
        "what": "ރިކަވަރީ ކޯޑްތައް",
        "acknowledge": "އަހަރެން އެބަހުރި ރައްކާކުރެވިފައި މިތަކެތި ކޯޑްތައް ކޮންމެވެސް ތާކު ރައްކާތެރި",
        "continue": "ކުރިއަށް އަށް ކޮންސޯލް"
      },
      "wrongAccount": "ގޯސް އަކްކައުންޓް?"
    },
    "backToSignIn": "ފަހަތަށް އަށް ސައިން އިން",
    "forgot": {
      "title": "ރީސެޓް ތިޔަ ފަރާތުގެ ޕާސްވޯޑް",
      "description": "ބާވަތް އެ އެޑްރެސް ތިޔަ ފަރާތުގެ ޕްލެޓްފޯމް އެޑްމިން އަކްކައުންޓް ބޭނުންކުރޭ. އެއްވެސްހާލެއްގައި އެ ދިމާވުން އަކްޓިވް އަކްކައުންޓް, ރީސެޓް ލިންކް އީ އީމެއިލްޑް އަށް އެ.",
      "submit": "އީމެއިލް މެ ލިންކް",
      "sent": "އެއްވެސްހާލެއްގައި އެ އެޑްރެސް އެބަހުރި ޕްލެޓްފޯމް އެޑްމިން އަކްކައުންޓް, ލިންކް އީ މަތީގައި އޭގެ ވޭ. އެ މުއްދަތު ހަމަވޭ ގައި ގަޑިއިރު, އެހެންކަމުން ބޭނުންކުރޭ އެ ސޫން.",
      "noEnumeration": "އެ ޖަވާބު އީ އެއް ދެގޮތުންވެސް — މި ޞަފްޙާ ވާނެ ނޫން ބުނޭ ތިޔަ ފަރާތް ކާގެ އެޑްރެސް އީ ރެގިސްޓެރެޑް.",
      "failed": "އެ ރީސެޓް ލިންކް ކުރެވޭނެ ނޫން ވުން ރިކުއެސްޓެޑް. މަސައްކަތްކުރޭ އަލުން."
    },
    "reset": {
      "title": "ހޮވާ އާ ޕާސްވޯޑް",
      "intro": "މި ލިންކް ކުރެވޭނެ ވުން ބޭނުންކުރެވިފައި އެއްފަހަރު. ހޮވާ ޕާސްވޯޑް ތިޔަ ފަރާތް ކުރޭ ނޫން ބޭނުންކުރޭ ކޮންމެވެސްތާކު އެހެން.",
      "newPassword": "އާ ޕާސްވޯޑް",
      "passwordHint": "ގައި މަދުވެގެން 12 އަކުރު. ށޮރްޓް ސެންޓެންކް ތިޔަ ފަރާތް ވާނެ ރެމެމްބެރް މަސައްކަތްކުރޭ ވެލްލް.",
      "confirmPassword": "ބާވަތް އެ އަލުން",
      "tooShort": "ބޭނުންކުރޭ ގައި މަދުވެގެން 12 އަކުރު.",
      "mismatch": " ދޭއް ޕަސްސްވޮރްޑްސް ކުރޭ ނޫން ދިމާވުން.",
      "submit": "ރައްކާކުރޭ އާ ޕާސްވޯޑް",
      "missingToken": "މި ޞަފްޙާ ބޭނުން ލިންކް އިން ތިޔަ ފަރާތުގެ އީމެއިލް — ހުޅުވާ އެ އިން އެތާ އެއަށްވުރެ ވުރެ ޓްޔްޕިންގް އެޑްރެސް.",
      "requestAnother": "ފޮނުވާ މެ އާ ލިންކް",
      "failed": "އެ ލިންކް އީ ނެތް އިތުރަށް ސައްހަ. ލިންކްސް އެކްސްޕިރް އަދި ކުރެވޭނެ ހަމައެކަނި ވުން ބޭނުންކުރެވިފައި އެއްފަހަރު.",
      "doneTitle": "ޕާސްވޯޑް ބަދަލުކުރެވިއްޖެ",
      "doneBody": "ސައިން އިން ގައި ތިޔަ ފަރާތުގެ އާ ޕާސްވޯޑް. މި ކޮންސޯލް ވާނެ ދެން އަހާ ށްޓަކައި ތިޔަ ފަރާތުގެ އައުތެންޓިކަޓޮރް ކޯޑް."
    },
    "invite": {
      "title": "ސެޓް މައްޗަށް ތިޔަ ފަރާތުގެ އޮޕެރަޓޮރް އަކްކައުންޓް",
      "intro": "ތިޔަ ފަރާތް އެބަހުރި ވުން އިންވިޓެޑް ގޮތުގައި ޕްލެޓްފޯމް އެޑްމިނިސްޓްރަޓޮރް. ހޮވާ ޕާސްވޯޑް އަށް ނިންމާ ސެޓްޓިންގް މައްޗަށް އެ އަކްކައުންޓް.",
      "submit": "ސެޓް ޕާސްވޯޑް",
      "missingToken": "މި ޞަފްޙާ ބޭނުން ލިންކް އިން ތިޔަ ފަރާތުގެ އިންވިޓަޓިއޮން އީމެއިލް — ހުޅުވާ އެ އިން އެތާ އެއަށްވުރެ ވުރެ ޓްޔްޕިންގް އެޑްރެސް.",
      "failed": "އެ އިންވިޓަޓިއޮން އީ ނެތް އިތުރަށް ސައްހަ. އިންވިޓަޓިއޮންސް އެކްސްޕިރް — އަސްކް އޯނަރ އަށް ފޮނުވާ އާ އެއް.",
      "doneTitle": "އަކްކައުންޓް ތައްޔާރު",
      "doneBody": "ސައިން އިން ގައި ތިޔަ ފަރާތުގެ އާ ޕާސްވޯޑް. މުލްޓި-ފަކްޓޮރް އައުތެންޓިކަޓިއޮން އީ ބޭނުންވޭ ގައި މި ރެއަލްމް, އެހެންކަމުން އެ ދެން ފިޔަވަޅު އީ އެންރޮލްލިންގް އައުތެންޓިކަޓޮރް."
    }
  },
  "stepUp": {
    "title": "ތިޔައީ ތިޔަ ފަރާތްކަން ޔަޤީންކުރޭ",
    "reasons": {
      "support": "ޓެނަންޓް ބޭނުންކުރާ ފަރާތެއްގެ މައްޗަށް ޢަމަލުކުރުމަށް އޮތެންޓިކޭޓަރ ބޭނުންވެއެވެ.",
      "billing": "ބިލިންގ ބަދަލުކުރުމަށް އޮތެންޓިކޭޓަރ ބޭނުންވެއެވެ.",
      "tenant": "މި ޓެނަންޓް ބަދަލުކުރުމަށް އޮތެންޓިކޭޓަރ ބޭނުންވެއެވެ.",
      "generic": "މި ޢަމަލަށް އޮތެންޓިކޭޓަރ ބޭނުންވެއެވެ."
    },
    "description": "އޮތެންޓިކޭޓަރ އެޕުން ހަ އަދަދުގެ ކޯޑް އެތެރެކުރޭ. ކޯޑް ޤަބޫލުކުރެވުމާއެކު ތިޔަ ފެށި މަސައްކަތް ކުރިއަށް ދާނެއެވެ، އަދި އެތެރެކުރި އެއްވެސް އެއްޗެއް ގެއްލިގެން ނުދާނެއެވެ.",
    "codeLabel": "އޮތެންޓިކޭޝަން ކޯޑް",
    "submit": "ޔަގީންކުރޭ",
    "verifying": "ޔަގީންކުރަނީ",
    "waiting": "މިއަށް މަޑުކުރަނީ އެއް ޢަމަލެކެވެ. | މިއަށް މަޑުކުރަނީ {count} ޢަމަލެވެ.",
    "attemptsWarning": "ނުބައި ކޯޑުތައް ގުނަނީ ސައިން އިން ވުމަށް އޮންނަ ހަމަ އެ ލޮކްއައުޓް ހަމައިގެ ތެރެއަށެވެ.",
    "errors": {
      "code": "އެ ކޯޑް ޤަބޫލެއް ނުކުރެވުނެވެ. ދެންމެ މި ކޯޑް ބޭނުންކުރިނަމަ، އެޕުން ދެން ދައްކާ ކޯޑަށް މަޑުކުރޭ.",
      "lockout": "މާ ގިނަ ނުބައި ކޯޑު ޖަހައިފިއެވެ. މި އެކައުންޓް ކުޑަ ވަގުތުކޮޅަކަށް ބަންދުވެއްޖެއެވެ — ސައިން އިން ވުމަށް އޮންނަ ހަމަ އެ ހަމައެވެ.",
      "lockoutUntil": "މާ ގިނަ ނުބައި ކޯޑު ޖަހައިފިއެވެ. {time} ގެ ފަހުން އަލުން މަސައްކަތްކުރޭ.",
      "other": "ކޯޑް ޗެކްކުރެވޭ ގޮތެއް ނުވިއެވެ. ހިނދުކޮޅަކު ފަހުން އަލުން މަސައްކަތްކުރޭ."
    },
    "enrol": {
      "routedTitle": "އޮތެންޓިކޭޓަރ ސެޓަޕްކުރުން ފުރިހަމަކުރޭ",
      "routedDetail": "އެ ޢަމަލަށް ދެވަނަ ފެކްޓަރެއް ބޭނުންވެއެވެ، އަދި މި އެކައުންޓަށް އަދި އެއެއް ނުއުފެއްދޭނެއެވެ. ރަޖިސްޓަރީކުރުން ފުރިހަމަކޮށްފައި، އަލުން މަސައްކަތްކުރޭ."
    }
  },
  "dashboard": {
    "title": "ޕްލެޓްފޯމް",
    "description": "ޓެނަންޓް މިލްކިއްޔާތު, ގުޅުވާލުން މިންވަރު އަދި ދުޅަހެޔޮކަން ގެ ޚިދުމަތްތައް ފަހަތުގައި އެ.",
    "loadFailed": " ޑޭޝްބޯޑް ކުރެވުނު ނޫން ލޯޑް",
    "kpi": {
      "tenants": "ޓެނަންޓްތައް",
      "tenantsHelp": "ކޮންމެ ޓެނަންޓް ގައި ރެޖިސްޓްރީ, ކޮންމެ ގޮތެއްވިޔަސް އޭގެ ސްޓޭޓަސް.",
      "tenantsDrilldown": "ވިއު ހުރިހާ ޓެނަންޓްތައް",
      "active": "ހަރަކާތްތެރި",
      "activeDrilldown": "ވިއު ހަރަކާތްތެރި ޓެނަންޓްތައް",
      "suspended": "ސަސްޕެންޑްކުރެވިފައި",
      "suspendedDrilldown": "ވިއު ސަސްޕެންޑްކުރެވިފައި ޓެނަންޓްތައް",
      "behind": "ސްކީމާތައް ފަހަތުގައި",
      "behindHelp": "ޓެނަންޓްތައް ކާގެ ސްކީމާ ވަރޝަން އީ ފަހަތުގައި ޝިޕްކުރެވިފައި މައިގްރޭޝަންތައް, ނުވަތަ ކާގެ އެންމެފަހު މައިގްރޭޝަން ދޫކުރި އެ ޑަރޓީ. ހުޅުވާ ޓެނަންޓް އަށް މައިގްރޭޓްކުރޭ އެ.",
      "behindDrilldown": "ވިއު ޓެނަންޓްތައް"
    },
    "signups": {
      "title": "ސައިންއަޕްތައް",
      "description": "އާ ޓެނަންޓްތައް ކޮންމެ ދުވަސް.",
      "emptyTitle": "ނެތް ޓެނަންޓްތައް އެބަހުރި ވެފައި ގުޅުވާލެވިއްޖެ އަދި",
      "emptyDescription": "ގުޅުވާލާ ފުރަތަމަ އެއް އިން ޓެނަންޓްތައް ސްކްރީން.",
      "chartLabel": "އާ ޓެނަންޓްތައް ކޮންމެ ދުވަސް",
      "series": "ސައިންއަޕްތައް"
    },
    "health": {
      "title": "ޚިދުމަތުގެ ދުޅަހެޔޮކަން",
      "database": "ޑޭޓާބޭސް",
      "redis": "ރެޑިސް",
      "healthy": "ދުޅަހެޔޮ",
      "unreachable": "ނުފޯރާ"
    },
    "clusters": {
      "title": "ޓެނަންޓްތައް މެދުވެރިކޮށް ކްލަސްޓަރ",
      "description": "ކޮންތާކު ކޮންމެ ޓެނަންޓްގެ ސްކީމާ އުޅޭ.",
      "emptyTitle": "ނެތް ކްލަސްޓަރތައް ގައި ބޭނުންކުރޭ އަދި"
    },
    "revenueNote": "އާމްދަނީ އަދި ދޫކޮށްދިއުން ވަނީ ނޫން ދެއްކިފައި މިތާ. އެ ފަރާތްތައް ވަނީ ނެގިފައި އިން ސަބްސްކްރިޕްޝަންތައް, ކޮން ވަނީ ނޫން ބައި ގެ ޕްލެޓްފޯމް ޑޭޓާ މޮޑެލް އަދި, އަދި ސުމެއް ވީސް ކިޔާ ގޮތުގައި \"ނެތް އާމްދަނީ\" އެއަށްވުރެ ވުރެ \"ނޫން މިނެކިރާފައި\"."
  },
  "tenants": {
    "status": {
      "provisioning": {
        "label": "ޕްރޮވިޜަންކުރުން",
        "meaning": " ޕްރޮވިޜަންކުރުން ސާގާ އީ އަދިވެސް ހިނގަނީ. ބޭނުންކުރާ ފަރާތްތައް ނުކުރެވޭނެ ސައިން އިން އަދި."
      },
      "provisioningFailed": {
        "label": "ޕްރޮވިޜަންކުރުން ނާކާމިޔާބު",
        "meaning": " ޕްރޮވިޜަންކުރުން ފިޔަވަޅު ނާކާމިޔާބު. އަލުންފަށާ އެ އިން ޓެނަންޓްގެ ޕްރޮވިޜަންކުރުން ވިއު."
      },
      "active": {
        "label": "ހަރަކާތްތެރި",
        "meaning": "ފުރިހަމައަށް ޕްރޮވިޜަންކުރެވިފައި. ބޭނުންކުރާ ފަރާތްތައް ކުރެވޭނެ ސައިން އިން އަދި މަސައްކަތް އާންމުކޮށް."
      },
      "suspended": {
        "label": "ސަސްޕެންޑްކުރެވިފައި",
        "meaning": "ބޭނުންކުރާ ފަރާތްތައް ލިބޭ 403 ޖަވާބުތައް އަދި ބަލާ ސަސްޕެންޝަން ބެނަރ."
      },
      "archived": {
        "label": "އާކައިވްކުރެވިފައި",
        "meaning": " ސްކީމާ އެބަހުރި ވެފައި ޑަމްޕްކުރެވިފައި އަށް ސްޓޯރޭޖް އަދި ޑްރޮޕްކުރެވިއްޖެ."
      }
    },
    "list": {
      "title": "ޓެނަންޓްތައް",
      "description": "ކޮންމެ ޓެނަންޓް ގައި ރެޖިސްޓްރީ, އޭގެ ލައިފްސައިކަލް ސްޓޭޓަސް އަދި ކޮންތާކު އޭގެ ސްކީމާ އުޅޭ.",
      "tableLabel": "ޓެނަންޓްތައް",
      "onboard": "ޓެނަންޓެއް ގުޅުވާލާ",
      "roleNote": "ގުޅުވާލުން އަދި ލައިފްސައިކަލް އަމަލުތައް ބޭނުންވޭ އޯނަރު ނުވަތަ ސަޕޯޓް ރޯލް.",
      "loadFailed": "ޓެނަންޓްތައް ކުރެވުނު ނޫން ވުން ލޯޑްކުރެވިއްޖެ",
      "emptyTitle": "ނެތް ޓެނަންޓްތައް އަދި",
      "emptyDescription": "ގުޅުވާލާ ފުރަތަމަ ޓެނަންޓް އަށް ޕްރޮވިޜަންކުރޭ އޭގެ ސްކީމާ, ސީޑް އެ އަދި ދައުވަތު އޭގެ އެޑްމިނިސްޓްރޭޓަރު.",
      "searchLabel": "ހޯދާ ޓެނަންޓްތައް",
      "searchPlaceholder": "ހޯދާ ނަން ނުވަތަ ސްލުގް",
      "statusLabel": "ފިލްޓަރ މެދުވެރިކޮށް ސްޓޭޓަސް",
      "anyStatus": "ކޮންމެ ސްޓޭޓަސް",
      "noPlan": "ނެތް ޕްލޭން",
      "columns": {
        "tenant": "ޓެނަންޓް",
        "status": "ސްޓޭޓަސް",
        "plan": "ޕްލޭން",
        "region": "ސަރަހައްދު",
        "timezone": "ޓައިމްޒޯން",
        "users": "ބޭނުންކުރާ ފަރާތްތައް",
        "created": "އުފެއްދިއްޖެ",
        "lastSignIn": "އެންމެފަހު ސައިން އިން"
      }
    },
    "create": {
      "title": "ޓެނަންޓެއް ގުޅުވާލާ",
      "description": "އުފައްދާ ރެޖިސްޓްރީ ސަފު, ސްކީމާ, އޭގެ މައިގްރޭޝަންތައް, ސީޑް ޑޭޓާ އަދި ފުރަތަމަ އެޑްމިނިސްޓްރޭޓަރު — ގޮތުގައި އެއް ސާގާ ތިޔަ ފަރާތް ކުރެވޭނެ ބަލަހައްޓާ.",
      "roleWarning": "ގުޅުވާލުން ބޭނުންވޭ އޯނަރު ނުވަތަ ސަޕޯޓް ރޯލް. މި ފޯމް ވާނެ ވުން ބޭރުކުރެވިއްޖެ މެދުވެރިކޮށް ސާވަރ.",
      "detailsTitle": "ޓެނަންޓް ތަފްޞީލު",
      "nameLabel": "ޓެނަންޓް ނަން",
      "namePlaceholder": "ވެލާ ޓްރަޑިންގް ޕްޓެ",
      "nameRequired": "ޓެނަންޓް ނަން އީ ލާޒިމު.",
      "slugLabel": "ސްލުގް",
      "regionLabel": "ސަރަހައްދު",
      "regionHint": "ކޮންތާކު މި ޓެނަންޓްގެ މަސައްކަތްތައް ވަނީ ދެވޭ އިން.",
      "regionPlaceholder": "ހޮވާ ސަރަހައްދު",
      "regions": {
        "blr1": "ބަންގަލޮރް (blr1)",
        "sgp1": "ސިންގަޕޮރް (sgp1)",
        "fra1": "ފްރަންކްފުރްޓް (fra1)",
        "ams3": "އަމްސްޓެރްޑަމް (ams3)",
        "lon1": "ލޮންޑޮން (lon1)",
        "nyc3": "އާ ޔޮރްކް (nyc3)",
        "sfo3": "ސަން ފްރަންކިސްކޮ (sfo3)",
        "tor1": "ޓޮރޮންޓޮ (tor1)",
        "syd1": "ސްޔްޑްނޭ (syd1)"
      },
      "timezoneLabel": "ޓައިމްޒޯން",
      "timezoneHint": "IANA ޒޯން. ވިޔަފާރި ތާރީޚްތައް, މުއްދަތު އިންތައް އަދި ކޮންމެ ތާވަލުކުރެވިފައި ޖޮބް ހިނގާ ގައި އެ.",
      "timezoneHintOffset": "IANA ޒޯން. ވިޔަފާރި ތާރީޚްތައް, މުއްދަތު އިންތައް އަދި ކޮންމެ ތާވަލުކުރެވިފައި ޖޮބް ހިނގާ ގައި އެ. މިހާރު {offset}.",
      "timezoneInvalid": "ހޮވާ ޓައިމްޒޯން އިން ލިސްޓް.",
      "planLabel": "ޕްލޭން",
      "planHint": "ކަނޑައަޅާ ހައްގުވެފައިވާ މޮޑިއުލްތައް އަދި ލިމިޓްތައް.",
      "planHintNone": "ނެތް ހަރަކާތްތެރި ޕްލޭންތައް އޮތުން އަދި — ޓެނަންޓް ކުރެވޭނެ ވުން ގުޅުވާލެވިއްޖެ ނެތި އެއް އަދި ހަވާލުކުރެވިފައި ޕްލޭން ފަހުން.",
      "planPlaceholder": "ނެތް ޕްލޭން",
      "adminNameLabel": "އެޑްމިނިސްޓްރޭޓަރު ނަން",
      "adminNameRequired": "އެޑްމިނިސްޓްރޭޓަރު ނަން އީ ލާޒިމު.",
      "adminEmailLabel": "އެޑްމިނިސްޓްރޭޓަރު އީމެއިލް",
      "adminEmailHint": "ލިބޭ ދައުވަތު އެ ސެޓްކުރޭ އެ ފަރާތްތަކުގެ ޕާސްވޯޑް.",
      "adminEmailInvalid": "ލިޔެލާ އެޑްމިނިސްޓްރޭޓަރުގެ އީމެއިލް އެޑްރެސް.",
      "submit": "ޕްރޮވިޜަންކުރޭ ޓެނަންޓް",
      "failed": " ޓެނަންޓް ކުރެވުނު ނޫން ވުން އުފެއްދިއްޖެ.",
      "provisioningTitle": "ޕްރޮވިޜަންކުރުން",
      "provisioningRunning": "ހިނގަނީ — މި ވިއު އަޕްޑޭޓްކުރޭ އަމިއްލައަށް.",
      "provisioningFinished": "ނިމިއްޖެ.",
      "provisioningStopped": "ހުއްޓިއްޖެ ގައި ނާކާމިޔާބު ފިޔަވަޅު.",
      "openTenant": "ހުޅުވާ ޓެނަންޓް",
      "onboardAnother": "ގުޅުވާލާ އިތުރު",
      "resumedTitle": "ޕްރޮވިޜަންކުރުން އަލުންފެށިއްޖެ",
      "resumedBody": " ސާގާ ނަގައިފި މައްޗަށް އިން ނާކާމިޔާބު ފިޔަވަޅު.",
      "resumeFailed": "އަލުންފަށާ ނާކާމިޔާބު.",
      "credentialTiming": " ޕާސްވޯޑް އީ ވްރިޓްޓެން ފަހުން ޓެނަންޓް އީ ޕްރޮވިޜަންކުރެވިފައި, މަތިން ސެޕަރަޓް އެދުން — އެ އީ ދުވަހަކުވެސް ބައި ގެ ގުޅުވާލުން ޕޭލޯޑް, އެހެންކަމުން އެ އީ ނޫން ކެއުއެޑް ނުވަތަ ރައްކާކުރެވިފައި ކޮންމެ ތާކު މަތީގައި ވޭ.",
      "credentialRunning": "ސެޓްޓިންގް އަޑްމިނިސްޓްރަޓޮރްސް ޕާސްވޯޑް…",
      "credentialFailedTitle": " ޓެނަންޓް އީ ރީޑްޔް, ނަމަވެސް ސެޓްޓިންގް ޕާސްވޯޑް ނާކާމިޔާބު",
      "credentialFailedAdvice": " ޓެނަންޓް އަމިއްލައަށް އީ ޕްރޮވިޜަންކުރެވިފައި އަދި އުސަބްލް — ކުރޭ ނޫން ގުޅުވާލާ އެ އަލުން. އަލުން މަސައްކަތްކުރޭ މިތާ, ނުވަތަ ހުޅުވާ ޓެނަންޓް އަދި ސެޓް ޕާސްވޯޑް އިން އޭގެ ބޭނުންކުރާ ފަރާތްތައް ލިސްޓް.",
      "credentialRetry": "އަލުން މަސައްކަތްކުރޭ",
      "credentialFailed": " އަޑްމިނިސްޓްރަޓޮރްސް ޕާސްވޯޑް ކުރެވުނު ނޫން ވުން ސެޓް.",
      "credentialUserMissing": "ނެތް ބޭނުންކުރާ ފަރާތް އާއެކު އެޑްރެސް {email} ވި ފެނިފައި ގައި މި ޓެނަންޓް, އެހެންކަމުން އެތާ ވި ނޮބޮޑްޔް އަށް ސެޓް ޕާސްވޯޑް ށްޓަކައި.",
      "credentialDone": " ޕާސްވޯޑް ށްޓަކައި {email} އީ ސެޓް. އެ ފަރާތްތައް ވާނެ ވުން އެދޭނެ އަށް ހޮވާ އެ ފަރާތްތަކުގެ އަމިއްލަ ގައި ފުރަތަމަ ސައިން އިން އުންލެސްސް ތިޔަ ފަރާތް ޓުރްނެޑް އެ ނިއްވާ."
    },
    "slug": {
      "rule": "3–30 އަކުރު, ކުދި އަކުރު އަކުރުތައް, ޢަދަދުތައް އަދި އަންޑަރސްކޯރތައް ހަމައެކަނި. ދާއިމީ އެއްފަހަރު އުފެއްދިއްޖެ.",
      "required": "ސްލުގް އީ ލާޒިމު.",
      "tooShort": "ސްލުގް ލާޒިމު ވުން ގައި މަދުވެގެން 3 އަކުރު.",
      "tooLong": "ސްލުގް ލާޒިމު ވުން ގައި އެންމެ 30 އަކުރު.",
      "notLowercase": "ސްލުގް ލާޒިމު ވުން ކުދި އަކުރު — ބޮޑު އަކުރު އަކުރުތައް ވަނީ ނޫން ހުއްދަ.",
      "charset": "ސްލުގް ވެދާނެ ހިމެނޭ ހަމައެކަނި ކުދި އަކުރު އަކުރުތައް, ޢަދަދުތައް އަދި އަންޑަރސްކޯރތައް.",
      "reserved": "\"{slug}\" އީ ރިޒަރވްކުރެވިފައި. ހޮވާ އިތުރު ސްލުގް."
    },
    "provisioning": {
      "steps": {
        "registry_row": "އުފައްދާ ރެޖިސްޓްރީ ސަފު",
        "create_schema": "އުފައްދާ ޓެނަންޓް ސްކީމާ",
        "migrate_schema": "ބޭނުންކުރޭ ޓެނަންޓް މައިގްރޭޝަންތައް",
        "seed": "ސީޑް ފައިސާތައް, ލޯކަލައިޒޭޝަން ޕެކް, ރޯލްތައް އަދި ސީކުއެންސްތައް",
        "create_admin": "އުފައްދާ ޓެނަންޓް އެޑްމިނިސްޓްރޭޓަރު އަދި ފޮނުވާ ދައުވަތު",
        "activate": "ހަރަކާތްތެރިކުރޭ ޓެނަންޓް"
      },
      "stepStatus": {
        "pending": "ނުފެށޭ",
        "running": "ހިނގަނީ",
        "completed": "ނިމިއްޖެ",
        "failed": "ނާކާމިޔާބު"
      },
      "attempts": "{count} މަސައްކަތް | {count} މަސައްކަތްތައް",
      "failedNote": " ސާގާ ހުއްޓިއްޖެ ގައި ނާކާމިޔާބު ފިޔަވަޅު. އަލުންފެށުން ނަގާ މައްޗަށް އިން އެތާ — އެ ކުރޭ ނޫން އަލުންއުފައްދާ އެއްވެސްއެއްޗެއް އެ ކުރިންވެސް ކާމިޔާބުވި.",
      "resume": "ޕްރޮވިޜަންކުރުން އަލުންފަށާ",
      "resumeRoleNote": "އަލުންފެށުން ބޭނުންވޭ އޯނަރު ނުވަތަ ސަޕޯޓް ރޯލް.",
      "complete": "ހުރިހާ ފިޔަވަޅުތައް ފުރިހަމަވެއްޖެ. ޓެނަންޓް އީ ޕްރޮވިޜަންކުރެވިފައި އަދި އޭގެ އެޑްމިނިސްޓްރޭޓަރު އެބަހުރި ވެފައި ދައުވަތު ދެވިފައި.",
      "panelTitle": "ޕްރޮވިޜަންކުރުން ސާގާ",
      "panelDescription": " ހަޔެއް ފިޔަވަޅުތައް އެ އުފައްދާ ޓެނަންޓް.",
      "panelDescriptionFailed": "ހުއްޓިއްޖެ ގައި ނާކާމިޔާބު ފިޔަވަޅު.",
      "loadFailed": " ފިޔަވަޅު ލެޖަރ ކުރެވުނު ނޫން ވުން ކިޔާ",
      "resumedToast": "ޕްރޮވިޜަންކުރުން އަލުންފެށިއްޖެ",
      "resumeFailedToast": "އަލުންފަށާ ނާކާމިޔާބު"
    },
    "detail": {
      "fallbackTitle": "ޓެނަންޓް",
      "subtitle": "{slug} · ސްކީމާ {schema} · ކްލަސްޓަރ {cluster}",
      "loadFailed": "މި ޓެނަންޓް ކުރެވުނު ނޫން ވުން ލޯޑްކުރެވިއްޖެ",
      "tabsLabel": "ޓެނަންޓް ބައިތައް",
      "tabs": {
        "overview": "ޚުލާޞާ",
        "usage": "ބޭނުންކުރުން",
        "users": "ބޭނުންކުރާ ފަރާތްތައް",
        "audit": "އޮޑިޓް",
        "provisioning": "ޕްރޮވިޜަންކުރުން"
      },
      "settingsTitle": "ސެޓިންގްސް",
      "settingsDescription": "ބަދަލުތައް މިތާ ވަނީ އޮޑިޓްކުރެވޭ ދަށުގައި ތިޔަ ފަރާތުގެ ވަނަވަރު.",
      "nameLabel": "ޓެނަންޓް ނަން",
      "timezoneLabel": "ޓައިމްޒޯން",
      "timezoneHint": "ވިޔަފާރި ތާރީޚްތައް, މުއްދަތު އިންތައް އަދި ކޮންމެ ތާވަލުކުރެވިފައި ޖޮބް ހިނގާ ގައި މި ޒޯން.",
      "timezoneHintOffset": "ވިޔަފާރި ތާރީޚްތައް, މުއްދަތު އިންތައް އަދި ކޮންމެ ތާވަލުކުރެވިފައި ޖޮބް ހިނގާ ގައި މި ޒޯން. މިހާރު {offset}.",
      "timezoneChanged": "ބަދަލުކުރުން ޓައިމްޒޯން އީ ރެކޯޑްކުރެވިފައި މަތީގައި އޮޑިޓް ރެކޯޑް. އެ ނަގާ އެފްފެކްޓް ށްޓަކައި ދެން ދުވަހުގެ ވިޔަފާރި ތާރީޚްތައް އަދި ތާވަލުކުރެވިފައި ޖޮބްތައް; އެއްވެސްއެއްޗެއްނެތް ކުރިންވެސް ރައްކާކުރެވިފައި އީ އަލުން ލިޔެވޭނެ.",
      "planLabel": "ޕްލޭން",
      "planHint": "ކަނޑައަޅާ މޮޑިއުލްތައް އަދި ލިމިޓްތައް މި ޓެނަންޓް އީ ހައްގުވެފައި އަށް.",
      "planPlaceholder": "ނެތް ޕްލޭން",
      "planRetired": "{name} (ބޭނުންކުރުން ހުއްޓާލެވިފައި)",
      "planPrice": "{currency} {price} ކޮންމެ {interval}",
      "editRoleNote": "އެޑިޓްކުރުން ޓެނަންޓް ބޭނުންވޭ އޯނަރު ނުވަތަ ސަޕޯޓް ރޯލް.",
      "saveFailed": " ޓެނަންޓް ކުރެވުނު ނޫން ވުން އަޕްޑޭޓްކުރެވިއްޖެ.",
      "savedTitle": "ޓެނަންޓް އަޕްޑޭޓްކުރެވިއްޖެ",
      "savedBody": " ބަދަލު އީ ރެކޯޑްކުރެވިފައި މަތީގައި ޕްލެޓްފޯމް އޮޑިޓް ރެކޯޑް.",
      "registryTitle": "ރެޖިސްޓްރީ",
      "registry": {
        "slug": "ސްލުގް",
        "schema": "ސްކީމާ",
        "cluster": "ކްލަސްޓަރ",
        "region": "ސަރަހައްދު",
        "baseCurrency": "އަސާސީ ފައިސާ",
        "locale": "ލޯކޭލް",
        "storagePrefix": "ސްޓޯރޭޖް ޕްރިފިކްސް",
        "created": "އުފެއްދިއްޖެ",
        "activated": "ހަރަކާތްތެރިކުރެވިއްޖެ",
        "suspended": "ސަސްޕެންޑްކުރެވިފައި",
        "reason": "ސަބަބު"
      },
      "schemaTitle": "ސްކީމާ ވަރޝަން",
      "schemaDescription": "މައިގްރޭޝަންތައް ބޭނުންކުރެވިފައި އަށް މި ޓެނަންޓްގެ ސްކީމާ.",
      "schemaVersion": "ވަރޝަން {version} ގެ {latest}",
      "schemaDirty": " އެންމެފަހު މައިގްރޭޝަން ދޫކުރި މި ސްކީމާ ޑަރޓީ. މައިގްރޭޓްކުރުން ވާނެ އަލުން މަސައްކަތްކުރޭ އެ.",
      "schemaBehind": "ފަހަތުގައި ޝިޕްކުރެވިފައި މައިގްރޭޝަންތައް.",
      "schemaUpToDate": "މައްޗަށް އަށް ތާރީޚް.",
      "migrateNow": "މިހާރު މައިގްރޭޓްކުރޭ",
      "migratedTitle": "ސްކީމާ މައިގްރޭޓްކުރެވިއްޖެ",
      "migratedBody": "މިހާރު ގައި ވަރޝަން {version} ގެ {latest}.",
      "migrateFailed": "މައިގްރޭޝަން ނާކާމިޔާބު",
      "flagsTitle": "ފީޗަރ ފްލެގްތައް",
      "flagsDescription": "ކޮންމެ ޓެނަންޓަކަށް ސްވިޗްތައް ކިޔާ މެދުވެރިކޮށް API. ތަޅުދަނޑިތައް ވަނީ ސީދާ ގޮތުގައި ސާވަރ ރައްކާކުރޭ އެ ފަރާތްތަކަށް.",
      "flagsAddLabel": "އާ ފްލެގް ތަޅުދަނޑި",
      "flagsEmpty": "ނެތް ފީޗަރ ފްލެގްތައް ސެޓް. މި ޓެނަންޓް ތަބާވޭ އޭގެ ޕްލޭންގެ ހައްގުކުރުންތައް.",
      "flagsNote": "ފްލެގް ބަދަލުތައް ވަނީ ބޭނުންކުރެވިފައި އާއެކު ބަދަލުތައް ރައްކާކުރޭ.",
      "limitsTitle": "ކަސްޓަމް ލިމިޓްތައް",
      "limitsDescription": "އޯވަރރައިޑްތައް މަތީގައި މަތި ގެ ޕްލޭންގެ ލިމިޓްތައް. މުޅި ނަންބަރުތައް.",
      "limitsAddLabel": "އާ ލިމިޓް ތަޅުދަނޑި",
      "limitsEmpty": "ނެތް އޯވަރރައިޑްތައް. ޕްލޭން ލިމިޓްތައް ބޭނުންކުރޭ.",
      "limitsNote": "ލިމިޓް ބަދަލުތައް ވަނީ ބޭނުންކުރެވިފައި އާއެކު ބަދަލުތައް ރައްކާކުރޭ.",
      "suspend": "ސަސްޕެންޑްކުރޭ",
      "reactivate": "އަލުން ހަރަކާތްތެރިކުރޭ",
      "suspendTitle": "ސަސްޕެންޑްކުރޭ މި ޓެނަންޓް",
      "suspendConsequence": "އެ ފަރާތްތަކުގެ ބޭނުންކުރާ ފަރާތްތައް ވާނެ ލިބޭ 403 ޖަވާބުތައް އާއެކު ސަސްޕެންޝަން ބެނަރ އަދި ވާނެ ނޫން ވުން ކުޅަދާނަ އަށް ސައިން އިން ނުވަތަ ޕޯސްޓް އެއްވެސްއެއްޗެއް. ޑޭޓާ އީ ބީހިފައި ނުވާ އަދި އަލުން ހަރަކާތްތެރިކުރުން އަނބުރާ ގެންނަވާ އެކްސެސް ވަގުތުން.",
      "suspendConfirm": "ސަސްޕެންޑްކުރޭ ޓެނަންޓް",
      "suspendReasonHint": "ރެކޯޑްކުރެވިފައި މަތީގައި ޓެނަންޓް ރެކޯޑް އަދި އޮޑިޓް ރެކޯޑް.",
      "suspendedTitle": "ޓެނަންޓް ސަސްޕެންޑްކުރެވިފައި",
      "suspendedBody": "އޭގެ ބޭނުންކުރާ ފަރާތްތައް މިހާރު ލިބޭ 403 ޖަވާބުތައް.",
      "suspendFailed": " ޓެނަންޓް ކުރެވުނު ނޫން ވުން ސަސްޕެންޑްކުރެވިފައި.",
      "reactivateTitle": "އަލުން ހަރަކާތްތެރިކުރޭ މި ޓެނަންޓް",
      "reactivateConsequence": "އެ ފަރާތްތަކުގެ ބޭނުންކުރާ ފަރާތްތައް ކުރެވޭނެ ސައިން އިން އަދި މަސައްކަތް އަލުން ވަގުތުން. ސަސްޕެންޝަން ސްޓޭސް މަތީގައި އޮޑިޓް ރެކޯޑް.",
      "reactivateConfirm": "އަލުން ހަރަކާތްތެރިކުރޭ ޓެނަންޓް",
      "reactivatedTitle": "ޓެނަންޓް އަލުން ހަރަކާތްތެރިކުރެވިއްޖެ",
      "reactivatedBody": "އޭގެ ބޭނުންކުރާ ފަރާތްތައް ކުރެވޭނެ ސައިން އިން އަލުން.",
      "reactivateFailed": " ޓެނަންޓް ކުރެވުނު ނޫން ވުން އަލުން ހަރަކާތްތެރިކުރެވިއްޖެ."
    },
    "usage": {
      "loadFailed": "ބޭނުންކުރުން ކުރެވުނު ނޫން ވުން ލޯޑްކުރެވިއްޖެ",
      "rangeLabel": "ބޭނުންކުރުން ރޭންޖް",
      "range": {
        "days30": "އެންމެފަހު 30 ދުވަސްތައް",
        "days90": "އެންމެފަހު 90 ދުވަސްތައް",
        "days180": "އެންމެފަހު 180 ދުވަސްތައް",
        "months12": "އެންމެފަހު 12 މަސްތައް"
      },
      "activityTitle": "ހަރަކާތް",
      "activityDescription": "އެއްކުރެވިފައި މައްޗަށް ކޮންމެ ރެއަކު ކޮންމެ ޓެނަންޓް ދުވަސް.",
      "activityEmptyTitle": "ނެތް ބޭނުންކުރުން ރެކޯޑްކުރެވިފައި އަދި",
      "activityEmptyDescription": "ރޮލްލުޕްސް ފެންނާނެ ދުވަސް ފަހުން ޓެނަންޓް ފަށާ ވަމުން ބޭނުންކުރެވިފައި.",
      "activityChartLabel": "ޓެނަންޓް ހަރަކާތް ކޮންމެ ދުވަސް",
      "series": {
        "activeUsers": "ހަރަކާތްތެރި ބޭނުންކުރާ ފަރާތްތައް",
        "apiCalls": "API ކަލްލްސް",
        "documentsPosted": "ލިޔެކިޔުންތައް ޕޯސްޓްކުރެވިފައި",
        "aiTokens": "އޭއައި ޓޮކެންސް",
        "storage": "ސްޓޯރޭޖް"
      },
      "storageTitle": "ސްޓޯރޭޖް",
      "storageDescription": "ބައިޓް ހިފެހެއްޓިފައި ދަށުގައި މި ޓެނަންޓްގެ ސްޓޯރޭޖް ޕްރިފިކްސް.",
      "storageEmptyTitle": "ނެތް ސްޓޯރޭޖް ރެކޯޑްކުރެވިފައި އަދި",
      "storageEmptyDescription": "އެޓޭޗްމަންޓްތައް އަދި އުފެއްދިފައި ލިޔެކިޔުންތައް ވަނީ ގުނިފައި މިތާ އެއްފަހަރު އަޕްލޯޑްކުރެވިފައި.",
      "storageChartLabel": "ޓެނަންޓް ސްޓޯރޭޖް ކޮންމެ ދުވަސް"
    },
    "audit": {
      "tableLabel": "ޓެނަންޓް އޮޑިޓް ލޮގް",
      "loadFailed": " އޮޑިޓް ލޮގް ކުރެވުނު ނޫން ވުން ކިޔާ",
      "emptyTitle": "ނެތް އޮޑިޓް އެންޓްރީތައް އަދި",
      "emptyDescription": "ކޮންމެ އުފައްދާ, އަޕްޑޭޓް, ސްޓޭޓަސް ބަދަލު, ލޮގިން އަދި އެކްސްޕޯޓް އެތެރޭގައި މި ޓެނަންޓް އަރާ މިތާ.",
      "entityLabel": "އެންޓިޓީ",
      "entityPlaceholder": "އެންޓިޓީ, e.g. gl.journal",
      "actionLabel": "އަމަލު",
      "actionPlaceholder": "އަމަލު, e.g. ޕޯސްޓް",
      "columns": {
        "when": "ވަގުތު",
        "action": "އަމަލު",
        "entity": "އެންޓިޓީ",
        "actor": "އަމަލުކުރި ފަރާތް",
        "note": "ނޯޓް"
      }
    },
    "keyValue": {
      "keyInvalid": "ބޭނުންކުރޭ ކުދި އަކުރު އަކުރުތައް, ޢަދަދުތައް, ތިކިތައް ނުވަތަ އަންޑަރސްކޯރތައް (2–49 އަކުރު).",
      "keyExists": "އެ ތަޅުދަނޑި ކުރިންވެސް އެބައޮތް.",
      "limitsInvalid": "ލިމިޓްތައް ލާޒިމު ވުން މުޅި ނަންބަރުތައް.",
      "enable": "ހުޅުވާލާ {key}",
      "remove": "ނަގާ {key}"
    }
  },
  "support": {
    "session": {
      "title": "ސަޕޯޓް އެކްސެސް",
      "description": " ވަގުތު ކަނޑައެޅިފައިވާ, ހަމައެކަނި ކިޔޭ ޓޯކަން ށްޓަކައި ބެލުމަށް އެތެރޭގައި މި ޓެނަންޓް.",
      "intro": "ހުޅުވުން ސަޕޯޓް ސެޝަން އުފައްދާ ޓޯކަން އެ ކުރެވޭނެ ކިޔާ މި ޓެނަންޓް ށްޓަކައި ދޭއް ގަޑިއިރު. އެ ނުކުރެވޭނެ ބަދަލު އެއްވެސްއެއްޗެއް, ޓެނަންޓްގެ ބޭނުންކުރާ ފަރާތްތައް ބަލާ ބެނަރ ދަނޑިވަޅުގައި އެ އީ ހަރަކާތްތެރި, އަދި ކޮންމެ އެދުން ހެދި އާއެކު އެ އީ އޮޑިޓްކުރެވޭ ދަށުގައި ތިޔަ ފަރާތުގެ ވަނަވަރު.",
      "open": "ހުޅުވާ ސަޕޯޓް ސެޝަން",
      "roleNote": "ސަޕޯޓް އެކްސެސް ބޭނުންވޭ އޯނަރު ނުވަތަ ސަޕޯޓް ރޯލް.",
      "activeUntil": "ސެޝަން ހަރަކާތްތެރި ވަންދެން {expires}. މި ޓޯކަން އީ ދެއްކިފައި އެއްފަހަރު — އެ އީ ނޫން ރައްކާކުރެވިފައި މެދުވެރިކޮށް މި ކޮންސޯލް.",
      "tokenWhat": "ސަޕޯޓް ޓޯކަން",
      "revoke": "އުވާލާ ސެޝަން",
      "dialogTitle": "ހުޅުވާ ސަޕޯޓް ސެޝަން",
      "dialogDescription": "ހަމައެކަނި ކިޔޭ އެކްސެސް އަށް {tenant} ށްޓަކައި ދޭއް ގަޑިއިރު.",
      "dialogConsequence": " ޓޯކަން ކުރެވޭނެ ކިޔާ މި ޓެނަންޓްގެ ޑޭޓާ. އޭގެ ބޭނުންކުރާ ފަރާތްތައް ވާނެ ބަލާ “ސަޕޯޓް ސެޝަން ހަރަކާތްތެރި” ބެނަރ, އަދި ކޮންމެ އަމަލު ޓަކެން އާއެކު އެ އީ ރެކޯޑްކުރެވިފައި މަތީގައި އޮޑިޓް ރެކޯޑް ދަށުގައި ތިޔަ ފަރާތުގެ ނަން.",
      "dialogConfirm": "ހުޅުވާ ސެޝަން",
      "reasonHint": "ކީއްވެ ތިޔަ ފަރާތް ބޭނުން އެކްސެސް — މި އީ ރައްކާކުރެވިފައި މަތީގައި ސެޝަން އަދި ދެއްކިފައި އަށް އޮޑިޓަރުން.",
      "openedTitle": "ސަޕޯޓް ސެޝަން ހުޅުވިއްޖެ",
      "openedBody": "އެ މުއްދަތު ހަމަވޭ އަމިއްލައަށް ގައި ދޭއް ގަޑިއިރު.",
      "openFailed": " ސަޕޯޓް ސެޝަން ކުރެވުނު ނޫން ވުން ހުޅުވިއްޖެ.",
      "revokedTitle": "ސަޕޯޓް ސެޝަން އުވާލެވިއްޖެ",
      "revokedBody": " ޓޯކަން ނެތް އިތުރަށް މަސައްކަތްކުރޭ.",
      "revokeFailed": "ކުރެވުނު ނޫން އުވާލާ"
    },
    "users": {
      "tableLabel": "ޓެނަންޓް ބޭނުންކުރާ ފަރާތްތައް",
      "readOnlyNote": "ސަޕޯޓް އެހީތެރިކަން ބޭނުންވޭ އޯނަރު ނުވަތަ ސަޕޯޓް ރޯލް. މި ލިސްޓް އީ ހަމައެކަނި ކިޔޭ ށްޓަކައި ތިޔަ ފަރާތް.",
      "loadFailed": "މި ޓެނަންޓްގެ ބޭނުންކުރާ ފަރާތްތައް ކުރެވުނު ނޫން ވުން ލޯޑްކުރެވިއްޖެ",
      "emptyTitle": "ނެތް ބޭނުންކުރާ ފަރާތްތައް ގައި މި ޓެނަންޓް އަދި",
      "emptyDescription": " އެޑްމިނިސްޓްރޭޓަރު ދައުވަތު ދެވިފައި ތެރޭގައި ޕްރޮވިޜަންކުރުން ފެންނާނެ މިތާ އެއްފަހަރު ދައުވަތު އީ ބަލައިގަނެވިއްޖެ.",
      "actionsFor": "ސަޕޯޓް އަމަލުތައް ށްޓަކައި {email}",
      "actionFailed": "އެ އަމަލު ކުރި ނޫން ފުރިހަމަ.",
      "columns": {
        "user": "ބޭނުންކުރާ ފަރާތް",
        "status": "ސްޓޭޓަސް",
        "mfa": "އެމްއެފްއޭ",
        "lastSignIn": "އެންމެފަހު ސައިން އިން"
      },
      "actions": {
        "resetPassword": {
          "label": "ފޮނުވާ ޕާސްވޯޑް ރީސެޓް ލިންކް",
          "title": "ފޮނުވާ ޕާސްވޯޑް ރީސެޓް ލިންކް",
          "consequence": " ބޭނުންކުރާ ފަރާތް ލިބޭ އީމެއިލް އާއެކު ރީސެޓް ލިންކް މަތީގައި އެ ފަރާތްތަކުގެ އަމިއްލަ އެޑްރެސް, އަދި އެ ފަރާތްތަކުގެ މިހާރުގެ ޕާސްވޯޑް ބަހައްޓާ މަސައްކަތްކުރަނީ ވަންދެން އެ ފަރާތްތައް ބޭނުންކުރޭ އެ. މި ހެލްޕެރް ދައްކާ ތިޔަ ފަރާތް އެއްވެސްއެއްޗެއްނެތް — އެ އީ ހަމައެކަނި ޕަތް ކޮންތާކު ނޮބޮޑްޔް ނަމަވެސް ބޭނުންކުރާ ފަރާތް އެވެރް ކްނޯސް އެ ފަރާތްތަކުގެ ޕާސްވޯޑް, އެހެންކަމުން ޕްރެފެރް އެ ވެނެވެރް އެ ފަރާތްތައް އެބަހުރި މަސައްކަތްކުރަނީ މައިލްބޮކްސް. ބޭނުންކުރޭ “ސެޓް ޕާސްވޯޑް” ވަގުތު އެ ފަރާތްތައް ކުރޭ ނޫން.",
          "confirm": "ފޮނުވާ ލިންކް",
          "done": "ރީސެޓް ލިންކް ފޮނުވިއްޖެ"
        },
        "unlock": {
          "label": "ހުޅުވާލާ އަކްކައުންޓް",
          "title": "ހުޅުވާލާ މި އަކްކައުންޓް",
          "consequence": "ސާފުކުރޭ ނާކާމިޔާބު ލޮގިން ތަޅުލުން އެހެންކަމުން ބޭނުންކުރާ ފަރާތް ކުރެވޭނެ އަލުން މަސައްކަތްކުރޭ ވަގުތުން. އެ ކުރޭ ނޫން ބަދަލު އެ ފަރާތްތަކުގެ ޕާސްވޯޑް.",
          "confirm": "ހުޅުވާލާ",
          "done": "އަކްކައުންޓް ހުޅުވާލެވިއްޖެ"
        },
        "resetMfa": {
          "label": "ރީސެޓް މަލްޓި-ފެކްޓަރ އޮތެންޓިކޭޝަން",
          "title": "ރީސެޓް މަލްޓި-ފެކްޓަރ އޮތެންޓިކޭޝަން",
          "consequence": "ނަގާ ބޭނުންކުރާ ފަރާތުގެ އޮތެންޓިކޭޓަރު. އެ ފަރާތްތައް ވާނެ ވުން އެދޭނެ އަށް އެންރޯލްކުރޭ އާ އެއް މަތީގައި އެ ފަރާތްތަކުގެ ދެން ސައިން އިން, އަދި ވަންދެން އެ ފަރާތްތައް ކުރޭ އެ ފަރާތްތަކުގެ އަކްކައުންޓް އީ ރައްކާތެރިކުރެވިފައި މެދުވެރިކޮށް ޕާސްވޯޑް އެކަނި.",
          "confirm": "ރީސެޓް އެމްއެފްއޭ",
          "done": "އޮތެންޓިކޭޓަރު ރީސެޓް"
        },
        "resendInvite": {
          "label": "އަލުން ފޮނުވާ ދައުވަތު",
          "title": "އަލުން ފޮނުވާ ދައުވަތު",
          "consequence": "ދޫކުރޭ އާ ދައުވަތު ލިންކް އަދި އީމެއިލްކުރޭ އެ. ކޮންމެ ކުރީގެ ދައުވަތު ލިންކް ހުއްޓޭ މަސައްކަތްކުރަނީ.",
          "confirm": "އަލުން ފޮނުވާ",
          "done": "ދައުވަތު އަލުން ފޮނުވިއްޖެ"
        },
        "deactivate": {
          "label": "ހުއްޓާލާ ބޭނުންކުރާ ފަރާތް",
          "title": "ހުއްޓާލާ މި ބޭނުންކުރާ ފަރާތް",
          "consequence": " ބޭނުންކުރާ ފަރާތް ކުރެވޭނެ ނެތް އިތުރަށް ސައިން އިން އަދި އެ ފަރާތްތަކުގެ ސެޝަންތައް ނިމުން. އެ ފަރާތްތަކުގެ ރެކޯޑްތައް އަދި އޮޑިޓް ތާރީޚް ވަނީ ބެހެއްޓިފައި — މި އީ ނޫން ޑިލީޓްކުރުން.",
          "confirm": "ހުއްޓާލާ",
          "done": "ބޭނުންކުރާ ފަރާތް ހުއްޓާލެވިއްޖެ"
        },
        "revokeSessions": {
          "label": "މަޖުބޫރު ސައިން އައުޓް ހުރިހާ ތާކު",
          "title": "މަޖުބޫރު ސައިން އައުޓް ހުރިހާ ތާކު",
          "consequence": "ކޮންމެ ހަރަކާތްތެރި ސެޝަން އަދި ރިފްރެޝް ޓޯކަން ށްޓަކައި މި ބޭނުންކުރާ ފަރާތް އީ އުވާލެވިއްޖެ. އެ ފަރާތްތައް ވާނެ އެބަހުރި އަށް ސައިން އިން އަލުން މަތީގައި ކޮންމެ ޑިވައިސް.",
          "confirm": "ސައިން އެ ފަރާތްތަކަށް ބޭރަށް",
          "done": "ސެޝަންތައް އުވާލެވިއްޖެ"
        }
      }
    },
    "credentials": {
      "modeLabel": "ހޯ އެ ފަރާތްތައް ހޯދާ ގައި",
      "modeHint": " އިންވިޓަޓިއޮން އީ ހަމައެކަނި އޮޕްޓިއޮން ކޮންތާކު ނޮބޮޑްޔް ނަމަވެސް ބޭނުންކުރާ ފަރާތް އެވެރް ކްނޯސް އެ ފަރާތްތަކުގެ ޕާސްވޯޑް. އެހެން ދޭއް އޮތުން ށްޓަކައި އަކްކައުންޓްސް އާއެކު ނެތް މަސައްކަތްކުރަނީ މައިލްބޮކްސް.",
      "modes": {
        "invite": {
          "label": "ފޮނުވާ އިންވިޓަޓިއޮން",
          "hint": "އީމެއިލްކުރޭ ލިންކް. އެ ފަރާތްތައް ހޮވާ އެ ފަރާތްތަކުގެ އަމިއްލަ ޕާސްވޯޑް އަދި ތިޔަ ފަރާތް ދުވަހަކުވެސް ބަލާ އެއް. ރެކޮމްމެންޑެޑް."
        },
        "set": {
          "label": "ސެޓް ޕާސްވޯޑް",
          "hint": "ތިޔަ ފަރާތް ބާވަތް އެ އަދި ޕަސްސް އެ މަތީގައި ޔައުރްސެލްފް. ނެތް އީމެއިލް އީ ފޮނުވިއްޖެ."
        },
        "generate": {
          "label": "ގެނެރަޓް ޕާސްވޯޑް",
          "hint": "އަހަރެމެން މިންޓް އެއް އަދި ދައްކާ އެ އަށް ތިޔަ ފަރާތް އެއްފަހަރު. އެ އީ ރައްކާކުރެވިފައި ނޯހެރް އަދި ނުކުރެވޭނެ ވުން ލޫކެޑް މައްޗަށް އަލުން."
        }
      },
      "passwordLabel": "ޕާސްވޯޑް",
      "passwordHint": "ގައި މަދުވެގެން {min} އަކުރު. ލެންގްތް އީ މުޅި ގަވާއިދު — ނެތް ޗަރަކްޓެރް ކްލަސްސެސް ވަނީ ލާޒިމު.",
      "confirmLabel": "ޔަގީންކުރޭ ޕާސްވޯޑް",
      "show": "ދައްކާ",
      "hide": "ހިޑް",
      "passwordRequired": "ލިޔެލާ ޕާސްވޯޑް, ނުވަތަ ހޮވާ އިތުރު އޮޕްޓިއޮން އަބޮވް.",
      "passwordTooShort": "ބޭނުންކުރޭ ގައި މަދުވެގެން {min} އަކުރު.",
      "passwordTooLong": "ބޭނުންކުރޭ ގައި އެންމެ {max} އަކުރު.",
      "passwordAllSame": " ސިންގްލް ރެޕީޓެޑް ޗަރަކްޓެރް އީ ނޫން ޕާސްވޯޑް.",
      "mismatch": " ދޭއް ޕަސްސްވޮރްޑްސް ކުރޭ ނޫން ދިމާވުން.",
      "mustChangeLabel": "ބޭނުންވޭ ބޭނުންކުރާ ފަރާތް އަށް ބަދަލު އެ ގައި ފުރަތަމަ ސައިން އިން",
      "mustChangeDescription": "ރެކޮމްމެންޑެޑް. ޕާސްވޯޑް ތިޔަ ފަރާތް ސެޓް ހުއްޓޭ މަސައްކަތްކުރަނީ ވަގުތުކޮޅެއް އެ ފަރާތްތައް ހޮވާ އެ ފަރާތްތަކުގެ އަމިއްލަ, އެހެންކަމުން ކޮންއެއްޗެއް ތިޔަ ފަރާތް އެނގޭ މުއްދަތު ހަމަވޭ މެދުވެރިކޮށް އަމިއްލައަށް.",
      "mustChangeOffWarning": "އާއެކު މި އުންޓިކެޑް ތިޔަ ފަރާތް ބަހައްޓާ ކްނޯއިންގް ޕާސްވޯޑް އެ ދޭ މަތީގައި މަސައްކަތްކުރަނީ އިންޑެފިނިޓެލްޔް, އަދި އެހެންކަމުން ކުރޭ އަންޔޮން ތިޔަ ފަރާތް ޕަސްސް އެ އަށް. ދޫކުރޭ އެ ނިއްވާ ހަމައެކަނި ށްޓަކައި އަކްކައުންޓް އެ އީ ޑެލިބެރަޓެލްޔް ށަރެޑް."
    },
    "generatedPassword": {
      "title": "ޕާސްވޯޑް — ދެއްކިފައި އެއްފަހަރު",
      "onlyTimeShown": "މި އީ ހަމައެކަނި ވަގުތު މި ޕާސްވޯޑް އީ ޑިސްޕްލޭއެޑް. އެ އީ ރައްކާކުރެވިފައި ނޯހެރް އަދި ނުކުރެވޭނެ ވުން ރެޓްރީވެޑް އަލުން; އެއްވެސްހާލެއްގައި އެ އީ ލޮސްޓް, ސެޓް އާ އެއް ށްޓަކައި {subject}.",
      "copyWhat": "ޕާސްވޯޑް",
      "expiresAtFirstSignIn": " ބޭނުންކުރާ ފަރާތް ވާނެ ވުން އެދޭނެ އަށް ހޮވާ އެ ފަރާތްތަކުގެ އަމިއްލަ ޕާސްވޯޑް ގައި ފުރަތަމަ ސައިން އިން, ފަހުން ކޮން މި އެއް ހުއްޓޭ މަސައްކަތްކުރަނީ.",
      "doesNotExpire": "ތިޔަ ފަރާތް ޗޮސް ނޫން އަށް މަޖުބޫރު ބަދަލު, އެހެންކަމުން މި ޕާސްވޯޑް ދޭ މަތީގައި މަސައްކަތްކުރަނީ ވަންދެން ސޮމެބޮޑްޔް ބަދަލުތައް އެ.",
      "deliveryAdvice": "ހަންޑް އެ މަތިން ގައި މީހާ ނުވަތަ މަތީގައި ޗަންނެލް ތިޔަ ފަރާތް ޓްރުސްޓް. ކުރޭ ނޫން އީމެއިލް އެ — އިންބޮކްސް އީ ސީދާ ކޮންއެއްޗެއް އިންވިޓަޓިއޮން ޕަތް ވީސް އެބަހުރި ބޭނުންކުރެވިފައި.",
      "acknowledge": "އަހަރެން އެބަހުރި ރައްކާކުރެވިއްޖެ މި ޕާސްވޯޑް ކޮންމެވެސް ތާކު ރައްކާތެރި",
      "dismiss": "ނިމިއްޖެ"
    },
    "createUser": {
      "open": "އިތުރުކުރޭ ބޭނުންކުރާ ފަރާތް",
      "title": "އިތުރުކުރޭ ބޭނުންކުރާ ފަރާތް އަށް މި ޓެނަންޓް",
      "description": "އުފައްދާ އަކްކައުންޓް އެތެރޭގައި ޓެނަންޓްގެ އަމިއްލަ ސްކީމާ. ހުރިހާއެއްޗެއް މިތާ އީ ރެކޯޑްކުރެވިފައި މަތީގައި ޓެނަންޓްގެ އޮޑިޓް ރެކޯޑް ދަށުގައި ތިޔަ ފަރާތުގެ ނަން.",
      "nameLabel": "ފުރިހަމަ ނަން",
      "nameRequired": " ނަން އީ ލާޒިމު.",
      "emailLabel": "އީމެއިލް",
      "emailHint": "އެ ފަރާތްތަކުގެ ސައިން އިން އެޑްރެސް. އެ ލާޒިމު ވުން އުނިކެ ވިތިން މި ޓެނަންޓް.",
      "emailInvalid": "ލިޔެލާ އެ ފަރާތްތަކުގެ އީމެއިލް އެޑްރެސް.",
      "rolesLabel": "ރޯލް ކޯޑްތައް",
      "rolesHint": "ކޮމްމަސެޕަރަޓެޑް ކޯޑްތައް, e.g. އަކްކައުންޓަންޓް, އަޕް_ކްލެރްކް. ދޫކުރޭ ހުސް އަދި ޓެނަންޓްގެ އަމިއްލަ އެޑްމިނިސްޓްރޭޓަރު އަސްސިގްންސް ރޯލްތައް އިން އެތެރޭގައި އެ ފަރާތްތަކުގެ އެޕް, ކޮންތާކު ކަޓަލޮގުއެ އީ.",
      "overrideReasonLabel": "އޮވެރްރިޑް ސަބަބު",
      "overrideReasonHint": "މިތަކެތި ރޯލްތައް ކޮންފްލިކްޓް ދަށުގައި ވަކިކުރުން ގެ ޒިންމާތައް. ސޭއިންގް ކީއްވެ އީ ކޮންއެއްޗެއް ލެޓްސް ކޮމްބިނަޓިއޮން ތްރައުގް, އަދި އެ އީ ރައްކާކުރެވިފައި މަތީގައި އޮޑިޓް ސަފު.",
      "overrideReasonRequired": " ސަބަބު އީ ލާޒިމު އަށް އޮވެރްރިޑް ސެގްރެގަޓިއޮންއޮފްޑުޓީސް ކޮންފްލިކްޓް.",
      "submit": "އުފައްދާ ބޭނުންކުރާ ފަރާތް",
      "failed": " ބޭނުންކުރާ ފަރާތް ކުރެވުނު ނޫން ވުން އުފެއްދިއްޖެ.",
      "done": "ބޭނުންކުރާ ފަރާތް އުފެއްދިއްޖެ"
    },
    "setPassword": {
      "label": "ސެޓް ޕާސްވޯޑް",
      "title": "ސެޓް މި އުސެރްސް ޕާސްވޯޑް",
      "consequence": "މި ސައިން ކުރުވާ ބޭނުންކުރާ ފަރާތް ބޭރަށް ގެ ކޮންމެ ޑިވައިސް އަދި ސާފުކުރޭ ކޮންމެ އިންވިޓަޓިއޮން ނުވަތަ ރީސެޓް ލިންކް ކުރިންވެސް ފޮނުވިއްޖެ އަށް އެ ފަރާތްތަކަށް — އެތަކެތި ލިންކްސް ހުއްޓާ މަސައްކަތްކުރަނީ. ސެންޑިންގް ރީސެޓް ލިންކް އިންސްޓީޑް އީ ބެޓްޓެރް ޕަތް ވެނެވެރް އެ ފަރާތްތައް އެބަހުރި މަސައްކަތްކުރަނީ މައިލްބޮކްސް.",
      "submit": "ސެޓް ޕާސްވޯޑް",
      "failed": "އެ ޕާސްވޯޑް ކުރެވުނު ނޫން ވުން ސެޓް.",
      "done": "ޕާސްވޯޑް ސެޓް"
    }
  },
  "plans": {
    "title": "ޕްލޭންތައް",
    "description": "ކޮންއެއްޗެއް ޓެނަންޓް އީ ހައްގުވެފައި އަށް, އަދި ކޮންއެއްޗެއް އެ އީ ބިލްކުރެވޭ ށްޓަކައި.",
    "tableLabel": "ޕްލޭންތައް",
    "new": "އާ ޕްލޭން",
    "roleNote": "އުފެއްދުން އަދި އެޑިޓްކުރުން ޕްލޭންތައް ބޭނުންވޭ އޯނަރު ނުވަތަ ބިލިންގ ރޯލް.",
    "loadFailed": "ޕްލޭންތައް ކުރެވުނު ނޫން ވުން ލޯޑްކުރެވިއްޖެ",
    "emptyTitle": "ނެތް ޕްލޭންތައް އަދި",
    "emptyDescription": " ޕްލޭން އެއްކޮށްލާ މޮޑިއުލްތައް, ބޭނުންކުރާ ފަރާތުގެ ލިމިޓް އަދި އަގު. ޓެނަންޓްތައް ކުރެވޭނެ ވުން ގުޅުވާލެވިއްޖެ ނެތި އެއް އަދި ހަވާލުކުރެވިފައި ޕްލޭން ފަހުން.",
    "createFirst": "އުފައްދާ ފުރަތަމަ ޕްލޭން",
    "retired": "ބޭނުންކުރުން ހުއްޓާލެވިފައި",
    "allModules": "ހުރިހާ މޮޑިއުލްތައް",
    "moreModules": "+{count} އިތުރު",
    "columns": {
      "plan": "ޕްލޭން",
      "price": "އަގު",
      "billed": "ބިލްކުރެވޭ",
      "trial": "ޓްރަޔަލް",
      "userCap": "ބޭނުންކުރާ ފަރާތުގެ ލިމިޓް",
      "modules": "މޮޑިއުލްތައް",
      "status": "ސްޓޭޓަސް"
    },
    "interval": {
      "monthly": "މަހަކު",
      "annual": "އަހަރަކު"
    },
    "edit": {
      "newTitle": "އާ ޕްލޭން",
      "editTitle": "އެޑިޓްކުރޭ {name}",
      "newDescription": "ކޯޑްތައް ވަނީ ދާއިމީ އެއްފަހަރު އުފެއްދިއްޖެ.",
      "codeLabel": "ކޯޑް",
      "codeHint": "ދާއިމީ އައިޑެންޓިފަޔަރ ބޭނުންކުރެވިފައި މެދުވެރިކޮށް ހައްގުކުރުން ބެލުންތައް.",
      "codeInvalid": "ކުދި އަކުރު އަކުރުތައް, ޢަދަދުތައް, ޑޭޝްތައް އަދި އަންޑަރސްކޯރތައް; 2–30 އަކުރު.",
      "nameLabel": "ނަން",
      "namePlaceholder": "ގްރޯތް",
      "nameRequired": "ޕްލޭން ނަން އީ ލާޒިމު.",
      "descriptionLabel": "ތަފްޞީލު",
      "priceLabel": "އަގު",
      "priceHint": "ކޮންމެ ބިލިންގ މުއްދަތު.",
      "priceInvalid": "ލިޔެލާ އަދަދު ފަދަ ގޮތުގައި 499 ނުވަތަ 499.00.",
      "currencyLabel": "ފައިސާ",
      "currencyInvalid": "ތިން އަކުރުގެ ISO 4217 ކޯޑް, e.g. MVR.",
      "intervalLabel": "ބިލިންގ މުއްދަތު",
      "trialLabel": "ޓްރަޔަލް ދުވަސްތައް",
      "trialInvalid": "މުޅި ނަންބަރު ގެ ދުވަސްތައް.",
      "userCapLabel": "ބޭނުންކުރާ ފަރާތުގެ ލިމިޓް",
      "userCapHint": "ހުސް މާނައަކީ ލިމިޓެއް ނެތް.",
      "userCapPlaceholder": "ލިމިޓެއް ނެތް",
      "userCapInvalid": "މުޅި ނަންބަރު, ނުވަތަ ދޫކުރޭ ހުސް ށްޓަކައި ލިމިޓެއް ނެތް.",
      "sortLabel": "ތަރުތީބުކުރާ ގޮތް",
      "sortHint": "ދަށް ތަރުތީބުކުރޭ ފުރަތަމަ.",
      "modulesLegend": "ހައްގުވެފައިވާ މޮޑިއުލްތައް",
      "wildcardNote": "“ހުރިހާ މޮޑިއުލްތައް” ހައްގުކުރޭ ހުރިހާއެއްޗެއް; ވަކިވަކި ހޮވުންތައް ވަނީ ދޫކޮށްލެވޭ ދަނޑިވަޅުގައި އެ އީ މަތީގައި.",
      "activeLabel": "ހަރަކާތްތެރި",
      "activeDescription": " ބޭނުންކުރުން ހުއްޓާލެވިފައި ޕްލޭން ސްޓޭސް މަތީގައި ޓެނަންޓްތައް އެ ކުރިންވެސް އެބަހުރި އެ, ނަމަވެސް ނުކުރެވޭނެ ވުން ހޮވިފައި ށްޓަކައި އާ އޮނެސް.",
      "create": "ޕްލޭން އުފައްދާ",
      "save": "ޕްލޭން ރައްކާކުރޭ",
      "createdTitle": "ޕްލޭން އުފެއްދިއްޖެ",
      "updatedTitle": "ޕްލޭން އަޕްޑޭޓްކުރެވިއްޖެ",
      "saveFailed": " ޕްލޭން ކުރެވުނު ނޫން ވުން ރައްކާކުރެވިއްޖެ."
    },
    "modules": {
      "groups": {
        "everything": "ހުރިހާއެއްޗެއް",
        "foundation": "އަސާސް",
        "finance": "މާލީ",
        "operations": "ހިންގުން",
        "people": "މުވައްޒަފުން",
        "platform": "ޕްލެޓްފޯމް"
      },
      "all": "ހުރިހާ މޮޑިއުލްތައް",
      "org": "ޖަމާޢަތް",
      "gl": "އާންމު ލެޖަރ",
      "ap": "ދައްކަންޖެހޭ އެކައުންޓްތައް",
      "ar": "ލިބެންޖެހޭ އެކައުންޓްތައް",
      "cash": "ފައިސާ & ބޭންކް",
      "bankrec": "ބޭންކް ރިކޮންސިލިއޭޝަން",
      "budget": "ބަޖެޓްކުރުން",
      "assets": "ފިކްސްޑް އެސެޓްތައް",
      "consol": "އެއްކުރުން",
      "procurement": "ހޯދުން",
      "inventory": "ސްޓޮކް",
      "sales": "ވިއްކުން",
      "crm": "ސީއާރްއެމް",
      "mfg": "އުފެއްދުންތެރިކަން",
      "projects": "މަޝްރޫޢުތައް",
      "service": "ޚިދުމަތް",
      "hr": "އެޗްއާރް",
      "payroll": "މުސާރަ",
      "portal": "ޕޯޓަލްތައް",
      "reporting": "ރިޕޯޓްކުރުން",
      "ai": "AI ފަށަލަ"
    }
  },
  "billing": {
    "roleNote": "ރެކޮރްޑިންގް ޕޭމެންޓްސް އަދި ބަދަލުކުރުން ޕްލޭންތައް ބޭނުންވޭ އޯނަރު ނުވަތަ ބިލިންގ ރޯލް.",
    "planPrice": "{currency} {price} ކޮންމެ {interval}",
    "nav": {
      "label": "ބިލިންގ ބައިތައް",
      "subscriptions": "ސަބްސްކްރިޕްޝަންތައް",
      "invoices": "އިންވޮއިކެސް",
      "payments": "ޕޭމެންޓްސް"
    },
    "fields": {
      "tenant": "ޓެނަންޓް",
      "currentPlan": "މިހާރުގެ ޕްލޭން",
      "planPrice": "ޕްލޭން އަގު",
      "unitPrice": "އުނިޓް އަގު",
      "seats": "ސީޓްސް",
      "interval": "ބިލްކުރެވޭ",
      "trialDays": "ޓްރަޔަލް ދުވަސްތައް",
      "trialEnds": "ޓްރަޔަލް އެންޑްސް",
      "periodStart": "މުއްދަތު އިން",
      "periodEnd": "މުއްދަތު އަށް",
      "period": "މުއްދަތު",
      "cancelsAtPeriodEnd": "އެންޑްސް ގައި މުއްދަތު ނިމުން",
      "cancelledAt": "ކަންކެލްލެޑް",
      "invoice": "އިންވޮއިސް",
      "issuedOn": "ދޫކުރެވިއްޖެ",
      "dueOn": "ޑުއެ",
      "subtotal": "ސުބްޓޮޓަލް",
      "tax": "ޓަކްސް",
      "total": "ޓޮޓަލް",
      "paid": "ޕައިޑް",
      "balance": "ބެލެންސް",
      "amount": "އަދަދު",
      "quantity": "ކަންޓިޓްޔް",
      "lineDescription": "ތަފްޞީލު",
      "receivedOn": "ލިބިއްޖެ މަތީގައި",
      "method": "މެތޮޑް",
      "reference": "ރެފެރެންކް",
      "note": "ނޯޓް"
    },
    "subscriptionStatus": {
      "trialing": {
        "label": "ޓްރިއަލިންގް",
        "meaning": "ގައި އޭގެ ޓްރަޔަލް. އެއްވެސްއެއްޗެއްނެތް އެބަހުރި ވެފައި ބިލްކުރެވޭ އަދި."
      },
      "active": {
        "label": "ހަރަކާތްތެރި",
        "meaning": "ބިލިންގ އާންމުކޮށް ކޮންމެ މުއްދަތު."
      },
      "pastDue": {
        "label": "ފަހަނައަޅާ ޑުއެ",
        "meaning": " އިންވޮއިސް އީ އޮވެރްޑުއެ. ޑުންނިންގް އީ ހިނގަނީ އަދި ޚިދުމަތް އީ އަދިވެސް މަތީގައި."
      },
      "suspended": {
        "label": "ސަސްޕެންޑްކުރެވިފައި",
        "meaning": "ޚިދުމަތް އީ ކުޓް ނިއްވާ ށްޓަކައި ނޮންޕޭމެންޓް. އަލުން ހަރަކާތްތެރިކުރޭ އެއްފަހަރު އިންވޮއިސް އީ ސެޓްޓްލެޑް."
      },
      "cancelled": {
        "label": "ކަންކެލްލެޑް",
        "meaning": "ނިމިއްޖެ. އެއްވެސްއެއްޗެއްނެތް ފުރްތެރް އީ ބިލްކުރެވޭ."
      }
    },
    "invoiceStatus": {
      "draft": {
        "label": "ޑްރަފްޓް",
        "meaning": "ރައިސެޑް ނަމަވެސް ނޫން އަދި ދޫކުރެވިއްޖެ އަށް ޓެނަންޓް."
      },
      "open": {
        "label": "ހުޅުވާ",
        "meaning": "ދޫކުރެވިއްޖެ އަދި އަވައިޓިންގް ޕޭމެންޓް."
      },
      "paid": {
        "label": "ޕައިޑް",
        "meaning": "ސެޓްޓްލެޑް ގައި ފުރިހަމަ."
      },
      "void": {
        "label": "ވޮއިޑް",
        "meaning": "ވިތްޑްރަވްން. އެ އަދަދުތައް ޓޯއަރްޑްސް އެއްވެސްއެއްޗެއްނެތް އޯއެޑް."
      },
      "uncollectible": {
        "label": "އުންކޮލްލެކްޓިބްލް",
        "meaning": "ވްރިޓްޓެން ނިއްވާ ގޮތުގައި އުންރެކޮވެރަބްލް."
      }
    },
    "paymentMethod": {
      "bankTransfer": "ބޭންކް ޓްރަންސްފެރް",
      "cheque": "ޗެކެ",
      "cash": "ފައިސާ",
      "card": "ކަރްޑް"
    },
    "subscriptions": {
      "title": "ސަބްސްކްރިޕްޝަންތައް",
      "description": "ކޮންމެ ޓެނަންޓްގެ ޕްލޭން, ކޮންއެއްޗެއް އެ ބިލްލްސް ކޮންމެ މުއްދަތު, އަދި ކޮންތާކު އެ އީ ގައި އޭގެ ލައިފްސައިކަލް.",
      "tableLabel": "ސަބްސްކްރިޕްޝަންތައް",
      "statusLabel": "ސްޓޭޓަސް",
      "anyStatus": "ކޮންމެ ސްޓޭޓަސް",
      "clearTenantFilter": "ސާފުކުރޭ ޓެނަންޓް ފިލްޓަރ",
      "manage": "މެނޭޖްކުރޭ",
      "emptyTitle": "ނެތް ސަބްސްކްރިޕްޝަންތައް އަދި",
      "emptyDescription": "އަސްސިގްން ޕްލޭން އަށް ޓެނަންޓް އަދި އެ ވާނެ ފެންނާނެ މިތާ.",
      "loadFailed": "ސަބްސްކްރިޕްޝަންތައް ކުރެވުނު ނޫން ވުން ލޯޑްކުރެވިއްޖެ"
    },
    "detail": {
      "title": "ސުބްސްކްރިޕްޓިއޮން",
      "description": "ޕްލޭން, ބިލިންގ މުއްދަތު އަދި ލައިފްސައިކަލް ށްޓަކައި މި ޓެނަންޓް.",
      "panelTitle": "ސުބްސްކްރިޕްޓިއޮން",
      "viewInvoices": "ވިއު އިންވޮއިކެސް",
      "noneTitle": "މި ޓެނަންޓް އެބަހުރި ނެތް ސުބްސްކްރިޕްޓިއޮން",
      "noneDescription": "އަސްސިގްން ޕްލޭން އަށް ފަށާ ބިލިންގ. އެއްވެސްއެއްޗެއްނެތް އީ އިންވޮއިކެޑް ވަންދެން ޕްލޭން އީ ހަވާލުކުރެވިފައި.",
      "cancelScheduled": "މި ސުބްސްކްރިޕްޓިއޮން އީ ސެޓް އަށް ނިމުން މަތީގައި {date}. އަލުން ހަރަކާތްތެރިކުރޭ އެ އަށް ބަހައްޓާ ބިލިންގ.",
      "cancellationReason": "ސަބަބު ދެވިފައި: {reason}",
      "loadFailed": "މި ސުބްސްކްރިޕްޓިއޮން ކުރެވުނު ނޫން ވުން ލޯޑްކުރެވިއްޖެ"
    },
    "assign": {
      "title": "އަސްސިގްން ޕްލޭން",
      "intro": " ޕްލޭން ސެޓްކުރޭ ކޮންއެއްޗެއް މި ޓެނަންޓް އީ ހައްގުވެފައި އަށް އަދި ކޮންއެއްޗެއް އެ އީ ބިލްކުރެވޭ ކޮންމެ މުއްދަތު.",
      "planPlaceholder": "ހޮވާ ޕްލޭން",
      "planRequired": "ހޮވާ ޕްލޭން.",
      "seatsHint": "ދޫކުރޭ ހުސް އަށް ބޭނުންކުރޭ ޕްލޭންގެ އަމިއްލަ ބޭނުންކުރާ ފަރާތުގެ ލިމިޓް.",
      "seatsInvalid": "ސީޓްސް ލާޒިމު ވުން މުޅި ނަންބަރު.",
      "trialHint": "ދޫކުރޭ ހުސް އަށް ބޭނުންކުރޭ ޕްލޭންގެ އަމިއްލަ ޓްރަޔަލް ލެންގްތް.",
      "trialInvalid": "ޓްރަޔަލް ދުވަސްތައް ލާޒިމު ވުން މުޅި ނަންބަރު.",
      "submit": "އަސްސިގްން ޕްލޭން",
      "failed": " ޕްލޭން ކުރެވުނު ނޫން ވުން ހަވާލުކުރެވިފައި.",
      "doneTitle": "ޕްލޭން ހަވާލުކުރެވިފައި"
    },
    "changePlan": {
      "title": "ބަދަލު ޕްލޭން",
      "planLabel": "އާ ޕްލޭން",
      "planPlaceholder": "ހޮވާ ޕްލޭން",
      "planRequired": "ހޮވާ ޕްލޭން އަށް މޮވް އަށް.",
      "currentPlanHint": " ޕްލޭން މި ޓެނަންޓް އީ މަތީގައި މިހާރު.",
      "effectiveLabel": "ވަގުތު އެ ނަގާ އެފްފެކްޓް",
      "effectiveHint": "މި ޑެކިޑެސް ވެތެރް ކަސްޓަމަރު އީ ބިލްކުރެވޭ ޓްވިކް މި މޮންތް, އެހެންކަމުން އެތާ އީ ނެތް ޑެފައުލްޓް.",
      "effectiveRequired": "ހޮވާ ވަގުތު ބަދަލު ނަގާ އެފްފެކްޓް.",
      "effective": {
        "now": "ވަގުތުން",
        "nowHint": " މިހާރުގެ މުއްދަތު އީ ބަންދުކުރެވިފައި ނިއްވާ އަދި ބިލްކުރެވޭ, އަދި އާ މުއްދަތު ފަށާ ޓޮޑޭ މަތީގައި އާ ޕްލޭން. ކަސްޓަމަރު ސީސް ދޭއް ޗަރްގެސް މި މޮންތް.",
        "periodEnd": "ގައި ނިމުން ގެ މުއްދަތު މަތީގައި {date}",
        "periodEndHint": "މި މުއްދަތު އީ ބިލްކުރެވޭ ގޮތުގައި އެ ސްޓަންޑްސް އަދި އާ ޕްލޭން އަޕްޕްލީސް އިން ދެން ރެނެވަލް, އެހެންކަމުން އެތާ އީ އެއް ޗަރްގް މި މޮންތް."
      },
      "submit": "ބަދަލު ޕްލޭން",
      "failed": " ޕްލޭން ކުރެވުނު ނޫން ވުން ބަދަލުކުރެވިއްޖެ.",
      "doneTitle": "ޕްލޭން ބަދަލުކުރެވިއްޖެ"
    },
    "cancel": {
      "title": "ކެންސަލްކުރޭ ސުބްސްކްރިޕްޓިއޮން",
      "timingLabel": "ވަގުތު އަށް ހުއްޓާ",
      "timing": {
        "periodEnd": "ގައި ނިމުން ގެ މުއްދަތު މަތީގައި {date}",
        "periodEndHint": "އެ ފަރާތްތައް ބަހައްޓާ ޚިދުމަތް ކުރިންވެސް ބިލްކުރެވޭ ށްޓަކައި, އަދި ވަނީ ނޫން އިންވޮއިކެޑް އަލުން.",
        "now": "ވަގުތުން",
        "nowHint": "ބިލިންގ ހުއްޓޭ ޓޮޑޭ. އުނުސެޑް ބައި ގެ މުއްދަތު އީ ނޫން ރެފުންޑެޑް އިން މި ސްކްރީން."
      },
      "consequencePeriodEnd": "ބިލިންގ ހުއްޓޭ ފަހުން {date}. ޓެނަންޓް ބަހައްޓާ މަސައްކަތްކުރަނީ ވަންދެން ދެން އަދި ނެތް ފުރްތެރް އިންވޮއިސް އީ ރައިސެޑް.",
      "consequenceNow": "ބިލިންގ ހުއްޓޭ މިހާރު އަދި ނެތް ފުރްތެރް އިންވޮއިސް އީ ރައިސެޑް. އުނުސެޑް ބައި ގެ މިހާރުގެ މުއްދަތު އީ ނޫން ރެފުންޑެޑް އިން މި ސްކްރީން.",
      "reasonHint": "ރެކޯޑްކުރެވިފައި މަތީގައި ސުބްސްކްރިޕްޓިއޮން އަދި މަތީގައި އޮޑިޓް ރެކޯޑް.",
      "keep": "ބަހައްޓާ ސުބްސްކްރިޕްޓިއޮން",
      "submit": "ކެންސަލްކުރޭ ސުބްސްކްރިޕްޓިއޮން",
      "failed": " ސުބްސްކްރިޕްޓިއޮން ކުރެވުނު ނޫން ވުން ކަންކެލްލެޑް.",
      "doneTitle": "ސުބްސްކްރިޕްޓިއޮން ކަންކެލްލެޑް"
    },
    "reactivate": {
      "submit": "އަލުން ހަރަކާތްތެރިކުރޭ",
      "failed": " ސުބްސްކްރިޕްޓިއޮން ކުރެވުނު ނޫން ވުން އަލުން ހަރަކާތްތެރިކުރެވިއްޖެ.",
      "doneTitle": "ސުބްސްކްރިޕްޓިއޮން އަލުން ހަރަކާތްތެރިކުރެވިއްޖެ"
    },
    "invoices": {
      "title": "އިންވޮއިކެސް",
      "description": "ޕްލެޓްފޯމް އިންވޮއިކެސް ރައިސެޑް އަގައިންސްޓް ޓެނަންޓް ސަބްސްކްރިޕްޝަންތައް އަދި މެޓެރެޑް ބޭނުންކުރުން.",
      "tableLabel": "އިންވޮއިކެސް",
      "statusLabel": "ސްޓޭޓަސް",
      "anyStatus": "ކޮންމެ ސްޓޭޓަސް",
      "fromLabel": "ދޫކުރެވިއްޖެ އިން",
      "toLabel": "ދޫކުރެވިއްޖެ އަށް",
      "emptyTitle": "ނެތް އިންވޮއިކެސް އަދި",
      "emptyDescription": "ގެނެރަޓް ފުރަތަމަ ބިލިންގ މުއްދަތު އަދި އިންވޮއިކެސް ވާނެ ފެންނާނެ މިތާ.",
      "generateFirst": "ގެނެރަޓް ފުރަތަމަ ބިލިންގ މުއްދަތު",
      "loadFailed": "އިންވޮއިކެސް ކުރެވުނު ނޫން ވުން ލޯޑްކުރެވިއްޖެ"
    },
    "invoice": {
      "title": "އިންވޮއިސް",
      "description": "ލިނެސް, ޕޭމެންޓްސް އަދި އައުޓްސްޓަންޑިންގް ބެލެންސް, ސީދާ ގޮތުގައި ސާވަރ ކޮމްޕުޓެޑް އެ ފަރާތްތަކަށް.",
      "headerPanel": "އިންވޮއިސް",
      "linesPanel": "ލިނެސް",
      "linesTableLabel": "އިންވޮއިސް ލިނެސް",
      "noLinesTitle": "މި އިންވޮއިސް އެބަހުރި ނެތް ލިނެސް",
      "noLinesDescription": " އިންވޮއިސް އާއެކު ނެތް ލިނެސް ވި ރައިސެޑް އާއެކު އެއްވެސްއެއްޗެއްނެތް އަށް ބިލްލް ށްޓަކައި. ވޮއިޑް އެ އަދި ގެނެރަޓް މުއްދަތު އަލުން.",
      "paymentsPanel": "ޕޭމެންޓްސް",
      "paymentsTableLabel": "ޕޭމެންޓްސް އަގައިންސްޓް މި އިންވޮއިސް",
      "noPaymentsTitle": "އެއްވެސްއެއްޗެއްނެތް ލިބިއްޖެ އަދި",
      "noPaymentsDescription": "ރެކޯޑް ބޭންކް ޓްރަންސްފެރް, ޗެކެ ނުވަތަ ފައިސާ ޕޭމެންޓް އެއްފަހަރު މޮނޭ އެބަހުރި އަރްރިވެޑް.",
      "subtotalMismatch": " ލިނެސް މަތީގައި މި އިންވޮއިސް ކުރޭ ނޫން އިތުރުކުރޭ މައްޗަށް އަށް ސުބްޓޮޓަލް ސާވަރ ފޮނުވިއްޖެ. އެއްވެސްއެއްޗެއްނެތް މިތާ އެބަހުރި ވެފައި ރެކަލްކުލަޓެޑް އަށް ކޮވެރް އެ މައްޗަށް. ރެޕޮރްޓް މި ކުރިން އަކްޓިންގް މަތީގައި ފިގުރެސް.",
      "totalMismatch": " ސުބްޓޮޓަލް ޕްލުސް ޓަކްސް ކުރޭ ނޫން އެކަލް ޓޮޓަލް ސާވަރ ފޮނުވިއްޖެ. އެއްވެސްއެއްޗެއްނެތް މިތާ އެބަހުރި ވެފައި ރެކަލްކުލަޓެޑް އަށް ކޮވެރް އެ މައްޗަށް. ރެޕޮރްޓް މި ކުރިން އަކްޓިންގް މަތީގައި ފިގުރެސް.",
      "voidedReason": "ވޮއިޑެޑް: {reason}",
      "loadFailed": "މި އިންވޮއިސް ކުރެވުނު ނޫން ވުން ލޯޑްކުރެވިއްޖެ"
    },
    "payment": {
      "title": "ރެކޯޑް ޕޭމެންޓް",
      "appliesTo": "އަލްލޮކަޓެޑް އަށް އިންވޮއިސް {number}",
      "amountHint": "ގައި {currency}, ގޮތުގައި މޮނޭ އަރްރިވެޑް.",
      "amountInvalid": "ލިޔެލާ އަދަދު ގޮތުގައި ނަންބަރު.",
      "amountNotPositive": " އަދަދު ލާޒިމު ވުން އިތުރު ވުރެ ސުމެއް.",
      "receivedOnHint": " ތާރީޚް މޮނޭ އަރްރިވެޑް, ނޫން ތާރީޚް އެ އީ ކޭއެޑް ގައި.",
      "dateRequired": "ލިޔެލާ ތާރީޚް މޮނޭ އަރްރިވެޑް.",
      "referenceHint": " ބޭންކް ރެފެރެންކް ނުވަތަ ޗެކެ ނަންބަރު, އެހެންކަމުން އެ ކުރެވޭނެ ވުން ޓްރަކެޑް ފަހުން.",
      "referenceRequired": "ލިޔެލާ ރެފެރެންކް މޮނޭ އަރްރިވެޑް އާއެކު.",
      "overpaymentWarning": "އެ އީ {excess} އިތުރު ވުރެ މި އިންވޮއިސް އެބަހުރި އައުޓްސްޓަންޑިންގް. އެ އީ ރެކޯޑްކުރެވިފައި އަގައިންސްޓް މި އިންވޮއިސް އެކަނި; އެއްވެސްއެއްޗެއްނެތް އީ އަލްލޮކަޓެޑް އަށް ޓެނަންޓްގެ އެހެން އިންވޮއިކެސް އިން މި ސްކްރީން.",
      "overpaymentAcknowledge": "އަހަރެން އެބަހުރި ޗެކެޑް އަދަދު ލިބިއްޖެ.",
      "submit": "ރެކޯޑް ޕޭމެންޓް",
      "failed": " ޕޭމެންޓް ކުރެވުނު ނޫން ވުން ރެކޯޑްކުރެވިފައި.",
      "doneTitle": "ޕޭމެންޓް ރެކޯޑްކުރެވިފައި"
    },
    "payments": {
      "title": "ޕޭމެންޓްސް",
      "description": "ހުރިހާއެއްޗެއް ލިބިއްޖެ, މެދުވެރިކޮށް ތާރީޚް, އާއެކު ރެފެރެންކް އެ އަރްރިވެޑް ދަށުގައި.",
      "tableLabel": "ޕޭމެންޓްސް",
      "fromLabel": "ލިބިއްޖެ އިން",
      "toLabel": "ލިބިއްޖެ އަށް",
      "emptyTitle": "އެއްވެސްއެއްޗެއްނެތް ލިބިއްޖެ އަދި",
      "emptyDescription": "ޕޭމެންޓްސް ވަނީ ރެކޯޑްކުރެވިފައި މަތީގައި އިންވޮއިސް އެ ފަރާތްތައް ޕޭ. ހުޅުވާ އިންވޮއިސް އަށް ރެކޯޑް އެއް.",
      "loadFailed": "ޕޭމެންޓްސް ކުރެވުނު ނޫން ވުން ލޯޑްކުރެވިއްޖެ"
    },
    "void": {
      "title": "ވޮއިޑް އިންވޮއިސް",
      "consequence": " އިންވޮއިސް އީ ވިތްޑްރަވްން އަދި ހުއްޓޭ ކައުންޓިންގް ޓޯއަރްޑްސް ކޮންއެއްޗެއް ޓެނަންޓް އޯއެސް. އެ އީ ދުވަހަކުވެސް ޑިލީޓްކުރެވިއްޖެ އަދި އޭގެ ނަންބަރު އީ ދުވަހަކުވެސް ރެއުސެޑް.",
      "consequencePaid": "މި އިންވޮއިސް ކުރިންވެސް އެބަހުރި މޮނޭ ރެކޯޑްކުރެވިފައި އަގައިންސްޓް އެ. ވޮއިޑިންގް އެ ވިތްޑްރަވްސް ޑޮކުމެންޓް ނަމަވެސް ލީވެސް އެތަކެތި ޕޭމެންޓްސް ރެކޯޑްކުރެވިފައި, އެހެންކަމުން ރެކޮންކިލް އެ ފަރާތްތަކަށް ފުރަތަމަ.",
      "reasonHint": "ރެކޯޑްކުރެވިފައި މަތީގައި އިންވޮއިސް އަދި މަތީގައި އޮޑިޓް ރެކޯޑް.",
      "submit": "ވޮއިޑް އިންވޮއިސް",
      "failed": " އިންވޮއިސް ކުރެވުނު ނޫން ވުން ވޮއިޑެޑް.",
      "doneTitle": "އިންވޮއިސް ވޮއިޑެޑް"
    },
    "generate": {
      "title": "ގެނެރަޓް އިންވޮއިކެސް",
      "description": "އުފުލާ ޕްލެޓްފޯމް އިންވޮއިކެސް ށްޓަކައި އެއް ބިލިންގ މުއްދަތު.",
      "periodStart": "މުއްދަތު އިން",
      "periodEnd": "މުއްދަތު އަށް",
      "dateRequired": "ލިޔެލާ ތާރީޚް.",
      "endBeforeStart": " ނިމުން ގެ މުއްދަތު ނުކުރެވޭނެ ވުން ކުރިން އޭގެ ފަށާ.",
      "tenantLabel": "އެއް ޓެނަންޓް ހަމައެކަނި",
      "tenantHint": "ދޫކުރޭ ހުސް އަށް ބިލްލް ކޮންމެ އެލިގިބްލް ޓެނަންޓް.",
      "allTenants": "ހުރިހާ ޓެނަންޓްތައް",
      "idempotencyNote": " ހިނގާ އީ އިޑެމްޕޮޓެންޓް: ޓެނަންޓް ކުރިންވެސް އިންވޮއިކެޑް ށްޓަކައި މިތަކެތި ތާރީޚްތައް އީ ސްކިޕްޕެޑް, ދުވަހަކުވެސް ބިލްކުރެވޭ ޓްވިކް.",
      "review": "ރެވީވް",
      "back": "ފަހަތަށް",
      "submit": "ގެނެރަޓް އިންވޮއިކެސް",
      "confirmAll": "އިންވޮއިކެސް ވާނެ ވުން ރައިސެޑް ށްޓަކައި ކޮންމެ އެލިގިބްލް ޓެނަންޓް ށްޓަކައި މުއްދަތު އިން {start} އަށް {end}.",
      "confirmOne": " އިންވޮއިސް ވާނެ ވުން ރައިސެޑް ށްޓަކައި {tenant} ށްޓަކައި މުއްދަތު އިން {start} އަށް {end}.",
      "confirmDetail": "ޓެނަންޓްތައް ކުރިންވެސް އިންވޮއިކެޑް ށްޓަކައި މި މުއްދަތު ވަނީ ސްކިޕްޕެޑް. ބަލާ ތާރީޚްތައް ކުރިން ތިޔަ ފަރާތް ކުރިއަށް.",
      "failed": " އިންވޮއިސް ހިނގާ ކުރެވުނު ނޫން ވުން ފުރިހަމަވެއްޖެ.",
      "resultSummary": "ހިނގާ ށްޓަކައި މުއްދަތު އިން {start} އަށް {end}.",
      "noTenants": "ނެތް ޓެނަންޓް ވި އެލިގިބްލް ށްޓަކައި މި މުއްދަތު.",
      "tableLabel": "އިންވޮއިސް ހިނގާ އައުޓްކޮމް މެދުވެރިކޮށް ޓެނަންޓް",
      "outcome": {
        "generated": "އުފެއްދިފައި",
        "skipped": "ސްކިޕްޕެޑް"
      },
      "skippedMeaning": "ކުރިންވެސް އިންވޮއިކެޑް ށްޓަކައި މި މުއްދަތު."
    }
  },
  "admins": {
    "title": "ޕްލެޓްފޯމް އެޑްމިނިސްޓްރޭޓަރުން",
    "description": "ކާކު ކުރެވޭނެ ހިންގާ މި ޑިޕްލޯއިމަންޓް, އަދި އާއެކު ކޮންއެއްޗެއް ބާރު.",
    "tableLabel": "ޕްލެޓްފޯމް އެޑްމިނިސްޓްރޭޓަރުން",
    "invite": "އެޑްމިނިސްޓްރޭޓަރަކަށް ދައުވަތު ދޭ",
    "ownerOnlyNote": "ދައުވަތު ދިނުން, ބަދަލުކުރުން ރޯލްތައް, ހުއްޓާލުން އަދި ނެގުން އެޑްމިނިސްޓްރޭޓަރުން ވަނީ ހަމައެކަނި އޯނަރަށް އަމަލުތައް. ތިޔަ ފަރާތް ކުރެވޭނެ ބަލާ ލިސްޓް.",
    "loadFailed": "އެޑްމިނިސްޓްރޭޓަރުން ކުރެވުނު ނޫން ވުން ލޯޑްކުރެވިއްޖެ",
    "emptyTitle": "ނެތް އެޑްމިނިސްޓްރޭޓަރުން",
    "emptyDescription": "ގައި މަދުވެގެން އެއް އޯނަރު ލާޒިމު އޮތުން ށްޓަކައި މި ޑިޕްލޯއިމަންޓް އަށް ވުން ހިންގޭނެ.",
    "actionsFor": "އަމަލުތައް ށްޓަކައި {email}",
    "columns": {
      "administrator": "އެޑްމިނިސްޓްރޭޓަރު",
      "role": "ރޯލް",
      "status": "ސްޓޭޓަސް",
      "mfa": "އެމްއެފްއޭ",
      "lastSignIn": "އެންމެފަހު ސައިން އިން"
    },
    "roles": {
      "ownerHint": "ފުރިހަމަ ކޮންޓްރޯލް, ހިމެނޭގޮތުން އެހެން އެޑްމިނިސްޓްރޭޓަރުން",
      "supportHint": "ޓެނަންޓް ލައިފްސައިކަލް އަދި ސަޕޯޓް އެހީތެރިކަން",
      "billingHint": "ޕްލޭންތައް އަދި ބިލިންގ; ނެތް ސަޕޯޓް އެކްސެސް"
    },
    "inviteDialog": {
      "title": "ދައުވަތު އެޑްމިނިސްޓްރޭޓަރު",
      "description": "އެ ފަރާތްތައް ލިބޭ އީމެއިލް އާއެކު ލިންކް އެ ސެޓްކުރޭ އެ ފަރާތްތަކުގެ ޕާސްވޯޑް. މަލްޓި-ފެކްޓަރ އެންރޯލްކުރުން އީ ދެން ލާޒިމު ކުރިން އެ ފަރާތްތައް ކުރެވޭނެ ބޭނުންކުރޭ ކޮންސޯލް.",
      "roleHint": "އޯނަރުން ކުރެވޭނެ މެނޭޖްކުރޭ އެހެން އެޑްމިނިސްޓްރޭޓަރުން; ސަޕޯޓް އަދި ބިލިންގ ނުކުރެވޭނެ.",
      "submit": "ދައުވަތު ފޮނުވާ",
      "sentTitle": "ދައުވަތު ފޮނުވިއްޖެ",
      "sentBody": "{email} ކުރެވޭނެ މިހާރު ސެޓް ޕާސްވޯޑް.",
      "forbidden": "ހަމައެކަނި އޯނަރު ކުރެވޭނެ ދައުވަތު ޕްލެޓްފޯމް އެޑްމިނިސްޓްރޭޓަރުން.",
      "failed": " ދައުވަތު ކުރެވުނު ނޫން ވުން ފޮނުވިއްޖެ."
    },
    "roleDialog": {
      "title": "ރޯލް ބަދަލުކުރޭ",
      "note": " ބަދަލު ނަގާ އެފްފެކްޓް މަތީގައި އެ ފަރާތްތަކުގެ ދެން އެދުން; އެ އީ ރެކޯޑްކުރެވިފައި މަތީގައި ޕްލެޓްފޯމް އޮޑިޓް ރެކޯޑް.",
      "submit": "ރޯލް ބަދަލުކުރޭ",
      "changedTitle": "ރޯލް ބަދަލުކުރެވިއްޖެ",
      "changedBody": "{email} އީ މިހާރު {role}.",
      "forbidden": "ހަމައެކަނި އޯނަރު ކުރެވޭނެ ބަދަލު އެޑްމިނިސްޓްރޭޓަރުގެ ރޯލް.",
      "failed": " ރޯލް ކުރެވުނު ނޫން ވުން ބަދަލުކުރެވިއްޖެ."
    },
    "menu": {
      "changeRole": "ރޯލް ބަދަލުކުރޭ",
      "enable": "ރެއެނަބްލް",
      "disable": "ހުއްޓާލާ",
      "remove": "ނަގާ"
    },
    "confirm": {
      "removeTitle": "ނަގާ މި އެޑްމިނިސްޓްރޭޓަރު",
      "removeConsequence": "{email} ގެއްލޭ އެކްސެސް ވަގުތުން އަދި ކޮންމެ ސެޝަން އީ އުވާލެވިއްޖެ. އަކްކައުންޓް ސަފު އީ ޑިލީޓްކުރެވިއްޖެ — އޮޑިޓް ރެކޯޑް ބަހައްޓާ ރެކޯޑް ގެ ކާކު އެ ފަރާތްތައް ވި. މި ނުކުރެވޭނެ ވުން އަނބުރާ ނުގެނެވޭނެ.",
      "removeConfirm": "ނަގާ އެޑްމިނިސްޓްރޭޓަރު",
      "enableTitle": "ރެއެނަބްލް މި އެޑްމިނިސްޓްރޭޓަރު",
      "enableConsequence": "{email} ކުރެވޭނެ ސައިން އިން އަލުން އާއެކު އެ ފަރާތްތަކުގެ އެކްސިސްޓިންގް ޕާސްވޯޑް އަދި އޮތެންޓިކޭޓަރު.",
      "enableConfirm": "ރެއެނަބްލް",
      "disableTitle": "ހުއްޓާލާ މި އެޑްމިނިސްޓްރޭޓަރު",
      "disableConsequence": "{email} ކުރެވޭނެ ނެތް އިތުރަށް ސައިން އިން. އަކްކައުންޓް އަދި އޭގެ ތާރީޚް ވަނީ ބެހެއްޓިފައި, އަދި އެ ކުރެވޭނެ ވުން ރެއެނަބްލެޑް ގައި ކޮންމެ ވަގުތު.",
      "disableConfirm": "ހުއްޓާލާ",
      "doneTitle": "ނިމިއްޖެ",
      "forbidden": "ހަމައެކަނި އޯނަރު ކުރެވޭނެ ބަދަލު ޕްލެޓްފޯމް އެޑްމިނިސްޓްރޭޓަރުން.",
      "failed": "އެ އަމަލު ކުރި ނޫން ފުރިހަމަ."
    }
  },
  "notFound": {
    "title": "އެ ސްކްރީން ކުރޭ ނޫން އޮތުން",
    "description": "އެއްވެސްއެއްޗެއްނެތް އީ ރޫޓްކުރެވިފައި ގައި {path}. އެ ވެދާނެ އެބަހުރި ވެފައި ލިންކް އަށް ސްކްރީން އެ އެބަހުރި ފަހުން ބަދަލުވެފައި, ނުވަތަ ޓައިޕޯ ގައި އެޑްރެސް ބާރ.",
    "dashboard": "ޕްލެޓްފޯމް ޑޭޝްބޯޑް",
    "tenants": "ޓެނަންޓްތައް"
  },
  "geotax": {
    "routes": {
      "geography": "ޖިއޮގްރަފީ",
      "taxPacks": "ޓެކްސް ޕެކްތައް",
      "taxPack": "ޓެކްސް ޕެކް",
      "adoption": "ޕެކް ބޭނުންކުރުން",
      "tenantTaxPacks": "ޓެނަންޓުގެ ޓެކްސް ޕެކްތައް"
    },
    "nav": {
      "group": "ލޯކަލައިޒޭޝަން",
      "geography": "ޖިއޮގްރަފީ",
      "taxPacks": "ޓެކްސް ޕެކްތައް",
      "adoption": "ބޭނުންކުރުން"
    },
    "roles": {
      "writeNote": "ޖިއޮގްރަފީ އެޑިޓްކުރުމަށް އޯނަރ ނުވަތަ ސަޕޯޓް ރޯލު ބޭނުންވެއެވެ.",
      "packWriteNote": "ޕެކް ޑްރާފްޓްކޮށް އެޑިޓްކުރުމަށް އޯނަރ ނުވަތަ ސަޕޯޓް ރޯލު ބޭނުންވެއެވެ.",
      "publishNote": "ޕެކް ޕަބްލިޝްކުރުމާއި އަނބުރާ ގެނައުން ޚާއްޞަވެފައިވަނީ އޯނަރ ރޯލަށެވެ."
    },
    "geography": {
      "title": "ޖިއޮގްރަފީ",
      "description": "ކޮންމެ ޓެނަންޓެއްގެ އެޑްރެސްތަކާއި ޓެކްސް ސަރަހައްދުތައް ބިނާވާ ގައުމު، ސަރަހައްދު އަދި ރަށްރަށުގެ މާސްޓަރ ލިސްޓެވެ.",
      "countriesLabel": "ގައުމުތައް",
      "searchLabel": "ގައުމުތައް ހޯދާ",
      "searchPlaceholder": "ނަން ނުވަތަ އައި.އެސް.އޯ ކޯޑު",
      "activeOnly": "ހަރަކާތްތެރި އެކަނި",
      "emptyTitle": "އަދި ގައުމެއް ނެތް",
      "emptyDescription": "އައި.އެސް.އޯ 3166 ލިސްޓު އިމްޕޯޓްކުރައްވާ، ނުވަތަ މި އިންސްޓޭންސް ހިންގާ ގައުމު އިތުރުކުރައްވާ.",
      "emptyFilteredTitle": "ގުޅޭ ގައުމެއް ނެތް",
      "emptyFilteredDescription": "މި ހޯދުމާ ގުޅޭ އެއްޗެއް ނެތެވެ. ފުރިހަމަ ލިސްޓު ބެލުމަށް ސާފުކުރައްވާ.",
      "addCountry": "ގައުމު އިތުރުކުރޭ",
      "importCountries": "އައި.އެސް.އޯ ލިސްޓު އިމްޕޯޓް",
      "loadFailed": "ގައުމުތަކުގެ ލިސްޓު ލޯޑެއް ނުކުރެވުނު.",
      "treeLoadFailed": "މި ގައުމުގެ ސަރަހައްދުތަކާއި ރަށްތައް ލޯޑެއް ނުކުރެވުނު.",
      "selectPrompt": "ގައުމެއް ހޮވާ",
      "selectPromptDescription": "ވާތްފަރާތުން ގައުމެއް ހޮވުމުން އޭގެ ސަރަހައްދުތަކާއި ރަށްތައް ފެނި، އެޑިޓްކުރެވޭނެއެވެ.",
      "addSubdivision": "{label} އިތުރުކުރޭ",
      "addLocality": "{label} އިތުރުކުރޭ",
      "noSubdivisions": "އަދި {label} ރެކޯޑުކޮށްފައެއް ނެތް",
      "noSubdivisionsDescription": "ފުރަތަމަ އެތި އިތުރުކުރައްވާ، ނުވަތަ ގައުމާއެކު އިމްޕޯޓްކުރައްވާ.",
      "inactive": "ހަރަކާތްތެރި ނޫން",
      "treeLabel": "{country} ގެ ޖިއޮގްރަފީ",
      "countTemplate": "{total} ން {active} ހަރަކާތްތެރި"
    },
    "validation": {
      "title": "އެޑްރެސް ސައްހަކުރުން",
      "description": "މި ގައުމުގެ ސަރަހައްދާއި ރަށުގެ މާސްޓަރާ އެއްގޮތަށް ޓެނަންޓުގެ އެޑްރެސް ފޯމު ހިފެހެއްޓޭ މިންވަރެވެ.",
      "enforce": "ލާޒިމު",
      "enforceHint": "އެޑްރެސް ރެކޯޑުކޮށްފައިވާ ސަރަހައްދަކާއި ރަށަކާ ގުޅެންޖެހޭނެއެވެ. އެހެން އެއްޗެއް ބަލައެއް ނުގަނެވޭނެއެވެ.",
      "warn": "އިންޒާރު",
      "warnHint": "ނުދަންނަ ސަރަހައްދެއް ނުވަތަ ރަށެއް ބަލައިގަނެ، އެތެރެކުރާ މީހާއަށް އަންގައިދެއެވެ.",
      "allow": "ހުއްދަ",
      "allowHint": "ބަލައިނުލައި ހުސް ލިޔުން ބަލައިގަނެއެވެ. މާސްޓަރ ލޯޑުނުކުރާ ގައުމުތަކަށެވެ."
    },
    "country": {
      "createTitle": "ގައުމެއް އިތުރުކުރޭ",
      "editTitle": "{name} އެޑިޓްކުރޭ",
      "createDescription": "އައި.އެސް.އޯ ކޯޑުތަކަކީ ރޯއެއްގެ އަމިއްލަވަންތަކަން ކަމުން، ފަހުން ބަދަލެއް ނުކުރެވޭނެއެވެ.",
      "editDescription": "އައި.އެސް.އޯ ކޯޑުތައް ބަދަލެއް ނުވާނެއެވެ. އެހެން ހުރިހާ އެއްޗެއް ރަނގަޅުކުރެވޭނެއެވެ.",
      "save": "ގައުމު ސޭވްކުރޭ",
      "create": "ގައުމު އިތުރުކުރޭ",
      "saveFailed": "ގައުމު ސޭވެއް ނުކުރެވުނު.",
      "iso2Hint": "ދެ އަކުރުގެ އައި.އެސް.އޯ 3166-1 އަލްފާ-2 ކޯޑު، މިސާލަކަށް MV.",
      "iso3Hint": "ތިން އަކުރުގެ އައި.އެސް.އޯ 3166-1 އަލްފާ-3 ކޯޑު، މިސާލަކަށް MDV.",
      "numericHint": "ތިން އަދަދުގެ އައި.އެސް.އޯ 3166-1 ނަމްބަރު ކޯޑު. ބޭނުމެއް ނުވޭ.",
      "currencyHint": "ގައުމުގެ ޕެކްތައް ފައިލްކުރާ އައި.އެސް.އޯ 4217 ކޯޑު، މިސާލަކަށް MVR.",
      "timezoneHint": "އައި.އޭ.އެން.އޭ ޒޯން، މިސާލަކަށް Indian/Maldives. މި ގައުމުގެ ޓެނަންޓުތަކުގެ ޑިފޯލްޓެވެ.",
      "labelsTitle": "މިތާނގައި ލެވެލްތަކަށް ކިޔާ ނަން",
      "labelsHint": "ދިވެހިރާއްޖޭގައި އަތޮޅާއި ރަށް، އެހެން ތަންތާނގައި ސްޓޭޓާއި ސިޓީ. މި ބަސްތައް ކޮންމެ ޓެނަންޓެއްގެ އެޑްރެސް ފޯމުގައި ފެންނާނެއެވެ.",
      "iso2Invalid": "ސީދާ ދެ އަކުރު ލިޔުއްވާ.",
      "iso3Invalid": "ސީދާ ތިން އަކުރު ލިޔުއްވާ.",
      "numericInvalid": "ސީދާ ތިން އަދަދު ލިޔުއްވާ، ނުވަތަ ހުސްކޮށް ބާއްވަވާ.",
      "currencyInvalid": "ތިން އަކުރުގެ އައި.އެސް.އޯ 4217 ކޯޑެއް ލިޔުއްވާ.",
      "nameRequired": "ނަމެއް ބޭނުންވެއެވެ.",
      "activeHint": "ހަރަކާތްތެރި ނޫން ގައުމެއް ޓެނަންޓުގެ އެޑްރެސް ފޯމުން ފޮރުވޭނެ، ނަމަވެސް ހުރި ރޯތައް ބާއްވާނެއެވެ."
    },
    "addressFormat": {
      "title": "އެޑްރެސް ފޯމެޓް",
      "description": "މި ގައުމުގައި އެޑްރެހެއްގައި ހިމެނެންޖެހޭ ބައިތަކާއި، އެބައިތަކުގެ ތަރުތީބާއި، ލޮކޭލިޓީއެއް ލިޔުމުގެ ބަދަލުގައި ޖިއޮގްރަފީ ގަހުން ހޮވަންޖެހޭތޯ.",
      "componentKeyPlaceholder": "ބައިގެ ކީ، މިސާލަކަށް line1",
      "required": "ބޭނުންވެއެވެ",
      "sourceFreeText": "ފްރީ ޓެކްސްޓް",
      "sourceGeo": "ޖިއޮގްރަފީ ރޯއަކާ ދިމާވާންޖެހޭނެ",
      "moveUp": "ބައި މައްޗަށް ގެންދޭ",
      "moveDown": "ބައި ތިރިއަށް ގެންދޭ",
      "remove": "ބައި ނައްތާލާ",
      "addComponent": "ބައި އިތުރުކުރޭ",
      "noComponents": "އަދި ބައިތަކެއް ނެތް — މިތާނގައި އެޑްރެހަކަށް ބޭނުންވަނީ ފުރަތަމަ ސަތުރެވެ.",
      "postalPattern": "ޕޯސްޓަލް ކޯޑު ޕެޓަން",
      "postalPatternHint": "ފައްތާފައިވާ ރެގިއުލާ އެކްސްޕްރެޝަނެއް، މިސާލަކަށް ^[0-9]{5}$. ޕޯސްޓަލް ސިސްޓަމެއް ނެތް ގައުމަކަށް ހުސްކޮށް ބާއްވަވާ.",
      "postalLabel": "ޕޯސްޓަލް ކޯޑު ލޭބަލް",
      "requiresGeoLocality": "ލޮކޭލިޓީ ޖިއޮގްރަފީ ރޯއަކާ ދިމާވާންޖެހޭނެ",
      "requiresGeoLocalityHint": "މިއޮން ކޮށްފިނަމަ، ލޮކޭޝަނެއްގެ ލޮކޭލިޓީ/ސަބްޑިވިޜަން ޖިއޮގްރަފީ ގަހުން ހޮވަންޖެހޭނެ، ފްރީ ޓެކްސްޓެއްގެ ގޮތުގައި ނުލިޔެ — މިއީ އޭގެ ޓެކްސް ޖުރިސްޑިކްޝަން ދެނެގަނެވޭ ގޮތް ހަދާ ސަބަބެވެ."
    },
    "subdivision": {
      "createTitle": "{label} އިތުރުކުރޭ",
      "editTitle": "{name} އެޑިޓްކުރޭ",
      "description": "ސަރަހައްދެއް އޮންނާނީ ސީދާ ގައުމުގެ ދަށުގައި، ނުވަތަ މަތީ ލެވެލްގެ އެހެން ސަރަހައްދެއްގެ ދަށުގައެވެ.",
      "save": "ސޭވްކުރޭ",
      "saveFailed": "ސަރަހައްދު ސޭވެއް ނުކުރެވުނު.",
      "levelHint": "އެންމެ މަތީ ސަރަހައްދަކަށް 1، އެހެން ސަރަހައްދެއްގެ ތެރޭގައިވާ އެއްޗަކަށް 2.",
      "parentNone": "މައި އެއްޗެއް ނެތް — ސީދާ ގައުމުގެ ދަށުގައި",
      "codeHint": "ގައުމުގެ ތެރޭގައި ތަފާތު ކުރު ކޯޑެއް. ސަރަހައްދު ކޯޑުތަކުގައި ފެންނާނެއެވެ.",
      "codeRequired": "ކޯޑެއް ބޭނުންވެއެވެ.",
      "nameRequired": "ނަމެއް ބޭނުންވެއެވެ."
    },
    "locality": {
      "createTitle": "{label} އިތުރުކުރޭ",
      "editTitle": "{name} އެޑިޓްކުރޭ",
      "description": "ރަށަކީ އެޑްރެސްކުރެވޭ އެންމެ ކުޑަ ބައެވެ — ރަށެއް، ސިޓީއެއް، ފްރީ ޒޯނެއް.",
      "save": "ސޭވްކުރޭ",
      "saveFailed": "ރަށް ސޭވެއް ނުކުރެވުނު.",
      "subdivisionNone": "ސަރަހައްދެއް ނެތް — ސީދާ ގައުމުގެ ދަށުގައި",
      "postalHint": "ގައުމުގައި ބޭނުންކުރާނަމަ ޕޯސްޓަލް ނުވަތަ ޒިޕް ކޯޑު.",
      "timezoneHint": "ގައުމުގެ ޒޯނާ ތަފާތުވާ ހާލަތުގައި އެކަނި.",
      "codeRequired": "ކޯޑެއް ބޭނުންވެއެވެ.",
      "nameRequired": "ނަމެއް ބޭނުންވެއެވެ."
    },
    "import": {
      "title": "ގައުމުތައް އިމްޕޯޓްކުރޭ",
      "description": "އައި.އެސް.އޯ 3166 ޑޭޓާގެ ރޯތައް ޕޭސްޓްކުރައްވާ. ހުރި ގައުމުތައް އަލްފާ-2 ކޯޑުން އަޕްޑޭޓްވެ، އައު ގައުމުތައް އުފެދޭނެއެވެ.",
      "inputLabel": "ގައުމުގެ ރޯތައް",
      "inputHint": "ކޮންމެ ސަތުރެއްގައި އެއް ގައުމު: iso2, iso3, ނަން, ފައިސާ. މިސާލަކަށް: MV, MDV, Maldives, MVR",
      "submit": "އިމްޕޯޓް",
      "parseError": "ސަތުރު {line} ކިޔައެއް ނުގަނެވުނު. ބޭނުންވަނީ: iso2, iso3, ނަން, ފައިސާ.",
      "emptyInput": "މަދުވެގެން އެއް ސަތުރު ޕޭސްޓްކުރައްވާ.",
      "failed": "އިމްޕޯޓް ނުހިނގި.",
      "resultTitle": "އިމްޕޯޓް ނިމިއްޖެ",
      "created": "އުފެއްދި",
      "updated": "އަޕްޑޭޓްކުރި",
      "skipped": "ދޫކޮށްލި",
      "errorsTitle": "ސާވަރުން ބަލައިނުގަތް ރޯތައް",
      "close": "ނިމުނީ"
    },
    "packs": {
      "title": "ޓެކްސް ޕެކްތައް",
      "description": "ގައުމެއްގެ ގާނޫނީ ކޮންޓެންޓް — ސަރަހައްދު، ރެޖީމް، ކޯޑު އަދި އެތަކެތި އެއްމައްޗަށް އަރާ ތަރުތީބުވެފައިވާ ގަވާއިދުތައް — ވަރޝަންކޮށް، އަޅާކިޔައި، ޓެނަންޓުތަކަށް ޕަބްލިޝްކުރެވެއެވެ.",
      "tableLabel": "ޓެކްސް ޕެކްތައް",
      "newPack": "އައު ޑްރާފްޓް",
      "countryFilter": "ގައުމު",
      "statusFilter": "ސްޓޭޓަސް",
      "anyCountry": "ކޮންމެ ގައުމެއް",
      "anyStatus": "ކޮންމެ ސްޓޭޓަސްއެއް",
      "emptyTitle": "އަދި ޓެކްސް ޕެކެއް ނެތް",
      "emptyDescription": "ޕެކަކީ އެއް ގައުމުގެ ގާނޫނީ ކޮންޓެންޓެވެ. ފުރަތަމަ ޑްރާފްޓް ހައްދަވައި، ދެން ޓެނަންޓުތަކަށް ޕަބްލިޝްކުރައްވާ.",
      "loadFailed": "ޕެކް ލިސްޓު ލޯޑެއް ނުކުރެވުނު.",
      "draftFirst": "ފުރަތަމަ ޕެކް ޑްރާފްޓްކުރޭ",
      "system": "ސިސްޓަމް"
    },
    "status": {
      "draft": "ޑްރާފްޓް",
      "draftMeaning": "އެޑިޓްކުރެވޭ. އެއްވެސް ޓެނަންޓަކަށް ނުފެންނާނެ.",
      "published": "ޕަބްލިޝްކުރި",
      "publishedMeaning": "ފްރީޒްކޮށްފައި. ޓެނަންޓުތަކަށް މި ވަރޝަން ބޭނުންކުރެވޭނެ.",
      "withdrawn": "އަނބުރާ ގެންދިޔަ",
      "withdrawnMeaning": "ދެން ނުދެވޭނެ. މިހާރު މީގައި ތިބި ޓެނަންޓުތައް މީގެ މައްޗަށް ބިނާވެ ދެމިއޮންނާނެ."
    },
    "create": {
      "title": "އައު ޓެކްސް ޕެކް ޑްރާފްޓް",
      "description": "ޑްރާފްޓެއް ފެށޭނީ ހުހަށް، ނުވަތަ ޕަބްލިޝްކޮށްފައިވާ ވަރޝަނެއްގެ ކޮޕީއެއްގެ ގޮތުގައެވެ.",
      "countryLabel": "ގައުމު",
      "countryHint": "މި ޕެކުން ގެންގުޅޭ ގާނޫނީ ކޮންޓެންޓްގެ ގައުމެވެ.",
      "countryPlaceholder": "ގައުމެއް ހޮވާ",
      "baseLabel": "ކޮޕީކުރާ ތަން",
      "baseHint": "އެ ވަރޝަނުގެ ހުރިހާ ކޮންޓެންޓެއް އައު ޑްރާފްޓަށް ކޮޕީކުރެއެވެ. ހުހަށް ފެށުމަށް ދޫކޮށްލައްވާ.",
      "baseNone": "ހުހަށް ފަށާ",
      "titleLabel": "ސުރުޚީ",
      "titleHint": "ބަދަލުވީ ކޯއްޗެއްކަމާއި ސަބަބު ކުރުކޮށް — މިސާލަކަށް \"2027 ޖެނުއަރީން ފެށިގެން TGST 17%\".",
      "submit": "ޑްރާފްޓް އުފައްދާ",
      "failed": "ޑްރާފްޓް ނުއުފެއްދުނު.",
      "countryRequired": "ގައުމެއް ހޮއްވަވާ."
    },
    "detail": {
      "loadFailed": "މި ޕެކް ލޯޑެއް ނުކުރެވުނު.",
      "notFound": "އެފަދަ ޕެކެއް ނެތް",
      "notFoundDescription": "ޑްރާފްޓެއްގެ ގޮތުގައި އޮއްވައި ފޮހެލެވިފައި ވެދާނެއެވެ.",
      "backToList": "ޓެކްސް ޕެކްތަކަށް އެނބުރި",
      "overview": "ޚުލާސާ",
      "content": "ކޮންޓެންޓް",
      "diff": "ބަދަލުތައް",
      "adoption": "ބޭނުންކުރުން",
      "changelogLabel": "ބަދަލުތަކުގެ ލޮގު",
      "changelogHint": "މި ވަރޝަން ބަލައިގަންނަންވީތޯ ނިންމާ ކޮންމެ ޓެނަންޓަކު ކިޔާނެއެވެ. ލިޔުއްވަންވީ އެމީހުންނަށެވެ.",
      "titleLabel": "ސުރުޚީ",
      "metaSaved": "ސޭވްކުރެވިއްޖެ.",
      "metaFailed": "ބަދަލު ސޭވެއް ނުކުރެވުނު.",
      "contentHash": "ކޮންޓެންޓް ހޭޝް",
      "contentHashHint": "ކެނޮނިކަލް ޕޭލޯޑުގެ SHA-256. ޓެނަންޓުގެ އެކްޓިވޭޝަނުގައި ރެކޯޑުވާތީ، ޕަބްލިޝްކުރި އެއްޗާ އެއްވަރުކަން ސާބިތުކުރެވެއެވެ.",
      "baseVersion": "ކޮޕީކުރީ",
      "submittedBy": "ހުށަހެޅީ",
      "publishedBy": "ޕަބްލިޝްކުރީ",
      "withdrawnBy": "އަނބުރާ ގެންދިޔައީ",
      "withdrawReason": "އަނބުރާ ގެންދިޔަ ސަބަބު",
      "immutable": "ޕަބްލިޝްކުރި ކޮންޓެންޓް ފްރީޒްކޮށްފައި",
      "immutableDescription": "މި ވަރޝަން އެޑިޓެއް ނުކުރެވޭނެއެވެ. ބަދަލެއް ގެންނަން މީގެ މައްޗަށް އައު ވަރޝަނެއް ޑްރާފްޓްކުރައްވާ.",
      "deleteTitle": "މި ޑްރާފްޓް ފޮހެލާ",
      "deleteConsequence": "ޑްރާފްޓާއި އޭގައިވާ ކޮންމެ ރޯއެއް ފޮހެވޭނެއެވެ. ޕަބްލިޝްކޮށްފައިވާ އެއްވެސް އެއްޗަކަށް އަސަރެއް ނުކުރާނެއެވެ.",
      "deleteConfirm": "ޑްރާފްޓް ފޮހެލާ",
      "deleteFailed": "ޑްރާފްޓް ފޮހެއެއް ނުލެވުނު."
    },
    "sections": {
      "title": "ޕޭލޯޑް",
      "description": "ޕެކެއް އެކުލެވެނީ އެގާރަ ތާވަލުންނެވެ. އޭގެ ތެރެއިން އެއް ތާވަލުގައި ތަރުތީބު މުހިންމުވެ، އެ ތާވަލު ފާހަގަކޮށްފައި ވެއެވެ.",
      "jurisdictions": "ސަރަހައްދުތައް",
      "jurisdictionsHint": "ޓެކްސް ޖިއޮގްރަފީ: ކޯޑެއް ގުޅުވޭ ގައުމު، ސަރަހައްދު އަދި ރަށު ލެވެލްތަކެވެ.",
      "regimes": "ރެޖީމްތައް",
      "regimesHint": "ކޮންމެ އެއްޗަކީ އެއް ފައިލްކުރުމުގެ ނިޒާމެކެވެ — ވެޓް، ހިފެހެއްޓޭ ޓެކްސް، ލެވީ، ސާވިސް ޗާޖު.",
      "tax-codes": "ޓެކްސް ކޯޑުތައް",
      "tax-codesHint": "ރޭޓުތައް، ފެށޭ ތާރީޚާއެކު. ޕަބްލިޝްކުރުމަށްފަހު ބަދަލެއް ނުކުރެވޭނެއެވެ.",
      "rules": "ގަވާއިދުތައް",
      "rulesHint": "ސަޕްލައިއަކަށް ކޮން ކޯޑެއްތޯ — މިސްރާބު، ސަޕްލައި ބާވަތް، ފަރާތުގެ ގިންތި އަދި ޗެނަލުން ގުޅުވެއެވެ.",
      "rule-entries": "ގަވާއިދުގެ އެންޓްރީތައް",
      "rule-entriesHint": "ގަވާއިދެއްގެ ތެރޭގައި އެއްމައްޗަށް އަރާ ތަރުތީބުވެފައިވާ ސްޓޭކެވެ. މިތާނގައި ތަރުތީބަކީ ހިސާބެކެވެ.",
      "pos-rules": "ސަޕްލައި ކުރެވޭ ތަން",
      "pos-rulesHint": "ފެށޭ ތަނުތޯ ނުވަތަ ދާ ތަނުތޯ ކަނޑައަޅައި، ދެފަރާތުންވެސް ރަޖިސްޓަރީ ނުވާނަމަ ވާނެ ގޮތެވެ.",
      "price-basis": "އަގުގެ ބިންގާ",
      "price-basisHint": "ޗެނަލެއްގެ އަގުތައް ޓެކްސް ހިމަނައިގެންތޯ ނުވަތަ ނުހިމަނައިތޯއެވެ.",
      "return-defs": "ރިޓަރން ތަޢާރަފު",
      "return-defsHint": "މި ރެޖީމުން ފައިލްކުރާ ފޯމުތަކާއި، ކިހާ ގިނައިންކަމެވެ.",
      "return-boxes": "ރިޓަރން ބޮކްސްތައް",
      "return-boxesHint": "ފޯމުގެ ކޮންމެ ބޮކްސްއަކާއި، އެއަށް އަރާ ޓެކްސް ސަތުރުތައް ކަނޑައަޅާ ޝަރުތެވެ.",
      "doc-rules": "ލިޔުމުގެ ގަވާއިދު",
      "doc-rulesHint": "ކޮންމެ ލިޔުމެއްގެ ގާނޫނީ ނަމްބަރު، ދޭތެރެ ނުކެނޑޭ ސިލްސިލާ، ބާތިލުކުރުމުގެ މާނަ އަދި އީ-އިންވޮއިސް.",
      "payroll-rules": "މުސާރައިގެ ގަވާއިދު",
      "payroll-rulesHint": "ގާނޫނީ މުސާރައިގެ ބައިތައް — ފައިސާ ދެއްކުން، ހައްދުތައް، އެންމެ މަދު ޗުއްޓީ."
    },
    "grid": {
      "addRow": "ރޯ އިތުރުކުރޭ",
      "deleteRow": "ރޯ ފޮހެލާ",
      "emptyTitle": "އަދި {section} ރޯއެއް ނެތް",
      "emptyDescription": "ފުރަތަމަ ރޯ އިތުރުކުރައްވާ، ނުވަތަ ޑްރާފްޓް އުފައްދާއިރު ޕަބްލިޝްކުރި ވަރޝަނެއް ކޮޕީކުރައްވާ.",
      "loadFailed": "މި ރޯތައް ލޯޑެއް ނުކުރެވުނު.",
      "readOnly": "މި ޕެކް ޕަބްލިޝްކޮށްފައި. އޭގެ ކޮންޓެންޓް ފްރީޒްކޮށްފައި.",
      "saveFailed": "ރޯ ސޭވެއް ނުކުރެވުނު.",
      "deleteFailed": "ރޯ ފޮހެއެއް ނުލެވުނު.",
      "deleteConsequence": "މި ޑްރާފްޓުން ރޯ ފޮހެވޭނެއެވެ. ޕަބްލިޝްކުރި ވަރޝަންތަކަށް އަސަރެއް ނުކުރާނެއެވެ.",
      "deleteConfirm": "ރޯ ފޮހެލާ",
      "deleteTitle": "{label} ފޮހެލަންތޯ؟",
      "staleReloaded": "މި ރޯ ހުޅުވައިގެން ހުއްޓައި އެހެން މީހަކު ބަދަލުކޮށްފި. އަލުން ލޯޑުކުރެވިއްޖެ — ބަދަލު އަލުން ގެނެސް ސޭވްކުރައްވާ.",
      "required": "މި ގޮޅި ފުރަން ޖެހެއެވެ.",
      "invalidJson": "މިއީ ސައްހަ JSON އެއް ނޫން.",
      "invalidNumber": "ފުރިހަމަ އަދަދެއް ލިޔުއްވާ.",
      "invalidDecimal": "ޑެސިމަލް އަދަދެއް ލިޔުއްވާ، މިސާލަކަށް 0.080000.",
      "createTitle": "{section} ރޯއެއް އިތުރުކުރޭ",
      "editTitle": "{label} އެޑިޓްކުރޭ",
      "jsonHint": "JSON އޮބްޖެކްޓެއް. ނެތްނަމަ ހުހަށް ބާއްވަވާ.",
      "actions": "ރޯގެ އަމަލުތައް"
    },
    "stack": {
      "title": "އެއްމައްޗަށް އެރުމުގެ ތަރުތީބު",
      "description": "ކޮންމެ އެންޓްރީއެއް ނަގަނީ އޭގެ ކުރީ އެންޓްރީ ދޫކުރާ ބިންގަލުގެ މައްޗަށެވެ. އެންޓްރީއެއް ބަދަލުކުރުމުން މި ގަވާއިދު ހިނގާ ކޮންމެ އިންވޮއިސްއެއްގެ ޓެކްސް ބަދަލުވެއެވެ.",
      "ruleLabel": "ގަވާއިދު",
      "rulePlaceholder": "ގަވާއިދެއް ހޮވާ",
      "noRules": "މި ޕެކުގައި އަދި ގަވާއިދެއް ނެތް",
      "noRulesDescription": "ފުރަތަމަ ގަވާއިދެއް އިތުރުކުރައްވާ؛ އެންޓްރީތައް ހުންނަނީ ގަވާއިދެއްގެ ދަށުގައެވެ.",
      "noEntries": "މި ގަވާއިދުން އަދި އެއްޗެއް ނުގުނާ",
      "noEntriesDescription": "ސްޓޭކަށް ފުރަތަމަ ޓެކްސް ކޯޑު އިތުރުކުރައްވާ. ފުރަތަމަ އެންޓްރީ އާންމުކޮށް ނަގަނީ ސާފު އަދަދުގެ މައްޗަށެވެ.",
      "addEntry": "ސްޓޭކަށް އިތުރުކުރޭ",
      "position": "ދަރަޖަ {n}",
      "onNet": "ސާފު އަދަދުގެ މައްޗަށް",
      "onNetPlus": "ސާފު އަދަދު + {codes} ގެ މައްޗަށް",
      "onNetPlusNothing": "ސާފު އަދަދުގެ މައްޗަށް — ކުރިން އެއްޗެއް ނެތް",
      "moveUp": "ކުރިއަށް ޖައްސާ",
      "moveDown": "ފަހަތަށް ޖައްސާ",
      "moveUpHint": "Alt + މައްޗަށް",
      "moveDownHint": "Alt + ތިރިއަށް",
      "reorderFailed": "ތަރުތީބު ސޭވެއް ނުކުރެވުނު. އެއްވެސް އެއްޗެއް ބަދަލެއް ނުވޭ.",
      "reordered": "ތަރުތީބު ސޭވްކުރެވިއްޖެ.",
      "listLabel": "{rule} ގެ އެއްމައްޗަށް އެރުމުގެ ސްޓޭކް",
      "warnFirstCompound": "ފުރަތަމަ އެންޓްރީ އަރަނީ އެއްވެސް އެއްޗެއްގެ މައްޗަކަށް ނޫނެވެ. އެއީ \"ސާފު އަދަދުގެ މައްޗަށް\" އާ އެއްގޮތެވެ — އެއަށް ސާފު އަދަދު ކަނޑައަޅުއްވާ، ނުވަތަ ކުރިއަށް ޗާޖެއް ގެންނަވާ.",
      "readOnly": "ޕަބްލިޝްކުރި ކޮންޓެންޓް ފްރީޒްކޮށްފައި. ތަރުތީބު ބަދަލުކުރަން އައު ވަރޝަނެއް ޑްރާފްޓްކުރައްވާ."
    },
    "diff": {
      "title": "ބަދަލުތައް",
      "description": "ޕަބްލިޝްކުރި ވަރޝަނަކާ އަޅާކިޔާއިރު މި ޕެކުން ބަދަލުކުރާ އެއްޗެވެ. ޕަބްލިޝްކުރުމުގެ ކުރިން ކިޔުއްވާ: މިތާނގައި ބަދަލުވާ ރޭޓެއް ޓެނަންޓު ނެރޭ ކޮންމެ އިންވޮއިސްއެއްގައި ބަދަލުވެއެވެ.",
      "againstLabel": "އަޅާކިޔާ ވަރޝަން",
      "againstHint": "އެ ގައުމުގެ ޕަބްލިޝްކޮށްފައިވާ ކޮންމެ ވަރޝަނަކާ.",
      "noBaseline": "އަޅާކިޔާނެ ޕަބްލިޝްކުރި ވަރޝަނެއް ނެތް",
      "noBaselineDescription": "މިއީ ގައުމުގެ ފުރަތަމަ ޕެކެވެ. މީގައިވާ ހުރިހާ އެއްޗަކީ އައު އެއްޗެކެވެ.",
      "identical": "ތަފާތެއް ނެތް",
      "identicalDescription": "މި ޕެކުގެ ޕޭލޯޑް v{version} އާ އެއްވަރެވެ.",
      "loadFailed": "އަޅާކިޔުން ލޯޑެއް ނުކުރެވުނު.",
      "added": "އިތުރުކުރި",
      "changed": "ބަދަލުކުރި",
      "withdrawn": "ނަގާލި",
      "addedCount": "{count} އިތުރުކުރި",
      "changedCount": "{count} ބަދަލުކުރި",
      "withdrawnCount": "{count} ނަގާލި",
      "sectionLabel": "{section} ގެ ތަފާތުތައް",
      "field": "ގޮޅި",
      "before": "ކުރިން",
      "after": "ފަހުން",
      "statutoryWarning": "މި އަޅާކިޔުމުން ރޭޓެއް ނުވަތަ ފެށޭ ތާރީޚެއް ބަދަލުވެއެވެ.",
      "statutoryWarningDescription": "މިހާރުގެ ވަރޝަނުގައި ތިބި ޓެނަންޓުތަކުން ބަލައިގަތުމުގެ ކުރިން ސައްހަކުރަން އެދެވޭނެއެވެ.",
      "filterAll": "ހުރިހާ އެއްޗެއް",
      "filterAdded": "އިތުރުކުރި އެކަނި",
      "filterChanged": "ބަދަލުކުރި އެކަނި",
      "filterWithdrawn": "ނަގާލި އެކަނި",
      "expandRow": "ގޮޅިތައް ދައްކާ",
      "collapseRow": "ގޮޅިތައް ފޮރުވާ"
    },
    "validationPanel": {
      "title": "ސައްހަކުރުން",
      "description": "މުޅި ޕޭލޯޑުގެ އޮނިގަނޑު ބެލުން — ނުގުޅޭ ރެފަރެންސް، ބުރު، އަދި ފެށޭ ތާރީޚުތައް ފުށުއެރުން.",
      "run": "ސައްހަކުރުން ހިންގާ",
      "running": "ބަލަނީ…",
      "valid": "ޕޭލޯޑް އެއްގޮތް",
      "validDescription": "ކޮންމެ ރެފަރެންސެއް ގުޅި، އެއްވެސް ގަވާއިދެއް އަނެއް ގަވާއިދާ ފުށެއް ނާރައެވެ.",
      "invalid": "{count} މައްސަލަ ފެނިއްޖެ | {count} މައްސަލަ ފެނިއްޖެ",
      "invalidDescription": "މި ހުރިހާ މައްސަލައެއް ހައްލުވަންދެން ޕެކް ޕަބްލިޝެއް ނުކުރެވޭނެއެވެ.",
      "failed": "ސައްހަކުރުން ނުހިންގުނު.",
      "issueSection": "ބައި",
      "issueRow": "ރޯ",
      "issueField": "ގޮޅި",
      "issueMessage": "މައްސަލަ",
      "notRunTitle": "އަދި ބަލާފައެއް ނެތް",
      "notRunDescription": "މި ޕޭލޯޑް ޕަބްލިޝްވާނެތޯ ބެލުމަށް އޮނިގަނޑުގެ ބެލުން ހިންގަވާ."
    },
    "publish": {
      "submitTitle": "ޕަބްލިޝްކުރަން ހުށަހަޅާ",
      "submitDescription": "ހުށަހެޅުމުން އެއްވެސް އެއްޗެއް ފްރީޒެއް ނުވެއެވެ. އެއިން ރެކޯޑުވަނީ މި ޑްރާފްޓް ތައްޔާރުކަމަށް ތިޔަ ދެކޭކަން، އެހެން އޮޕަރޭޓަރަކަށް ޕަބްލިޝްކުރެވޭނެގޮތަށެވެ.",
      "submitNoteLabel": "ބަދަލުވީ ކޯއްޗެއް",
      "submitNoteHint": "ޕަބްލިޝްކުރާ އޮޕަރޭޓަރު މި ކިޔާނެއެވެ. ބަދަލުވި އެއްޗާއި ފެށޭ ތާރީޚު ލިޔުއްވާ.",
      "submit": "ހުށަހަޅާ",
      "submitFailed": "ޕެކް ހުށަހެއް ނޭޅުނު.",
      "title": "v{version} ޕަބްލިޝްކުރޭ",
      "description": "ޕަބްލިޝްކުރުމުން މި ޕޭލޯޑް ފްރީޒްވެ، {country} ގެ ކޮންމެ ޓެނަންޓަކަށް ދެވެއެވެ.",
      "dualControlTitle": "އަބަދުވެސް ދެ އޮޕަރޭޓަރުން",
      "dualControlDescription": "ޕެކް ހުށަހެޅި އޮޕަރޭޓަރަށް އެ ޕެކް ޕަބްލިޝެއް ނުކުރެވޭނެއެވެ. މިއީ މި ސްކްރީނުން އެކަނި ނޫން، ޑޭޓާބޭސް އިންވެސް ހިފަހައްޓާ ކަމެކެވެ.",
      "youSubmitted": "މި ޕެކް ހުށަހެޅީ ތިޔަ ބޭފުޅާ ކަމުން، ޕަބްލިޝެއް ނުކުރެއްވޭނެއެވެ. އެހެން އޯނަރަކު ޖެހޭނެއެވެ.",
      "notSubmitted": "މި ޕެކް އަދި ހުށަހަޅާފައެއް ނެތެވެ. ފުރަތަމަ ހުށަހަޅުއްވާ.",
      "notValid": "މި ޕެކުގައި ހައްލުނުވާ {count} ސައްހަކުރުމުގެ މައްސަލަ އެބައޮތެވެ. ޕަބްލިޝްކުރުމުގެ ކުރިން ހައްލުކުރައްވާ. | މި ޕެކުގައި ހައްލުނުވާ {count} ސައްހަކުރުމުގެ މައްސަލަ އެބަހުއްޓެވެ. ޕަބްލިޝްކުރުމުގެ ކުރިން ހައްލުކުރައްވާ.",
      "summaryTitle": "ޓެނަންޓުތަކަށް ދެވޭނެ އެއްޗެއް",
      "summaryNone": "އަޅާކިޔުމެއް ނުހިންގާ. ބަދަލުވި އެއްޗެއް އެނގޭނަމަ އެކަނި ޕަބްލިޝްކުރައްވާ.",
      "noteLabel": "ޕަބްލިޝްކުރުމުގެ ނޯޓު",
      "noteHint": "އޮޑިޓް ރެކޯޑުގައި ބަހައްޓައި، ބަދަލުތަކުގެ ލޮގާއެކު ޓެނަންޓުތަކަށް ދައްކައެވެ.",
      "confirm": "ޕަބްލިޝްކުރޭ",
      "failed": "ޕެކް ޕަބްލިޝެއް ނުކުރެވުނު.",
      "withdrawTitle": "v{version} އަނބުރާ ގެންދޭ",
      "withdrawConsequence": "މި ވަރޝަން އައު ޓެނަންޓުތަކަށް ދިނުން ހުއްޓޭނެއެވެ. މިހާރު މީގައި ތިބި ޓެނަންޓުތައް މީގެ މައްޗަށް ބިނާވެ ދެމިއޮންނާނެ — އެމީހުން ޕޯސްޓްކޮށްފައިވާ އެއްޗަކަށް ބަދަލެއް ނާންނާނެއެވެ.",
      "withdrawConfirm": "ވަރޝަން އަނބުރާ ގެންދޭ",
      "withdrawReasonLabel": "ސަބަބު",
      "withdrawReasonHint": "އޮޑިޓް ރެކޯޑުގައި ބަހައްޓައި، މި ވަރޝަން ހިންގާ ޓެނަންޓުތަކަށް ދައްކައެވެ.",
      "withdrawFailed": "ވަރޝަން އަނބުރައެއް ނުގެންދެވުނު."
    },
    "adoption": {
      "title": "ޕެކް ބޭނުންކުރުން",
      "description": "ކޮން ޓެނަންޓަކު ކޮން ގައުމެއްގެ ޕެކުގެ ކޮން ވަރޝަނެއް ހިންގާތޯއާއި، އަޕްޑޭޓެއް ދޭންޖެހެނީ ކާކުތޯއެވެ.",
      "tableLabel": "ޓެނަންޓުން ބަލާއިރު ޕެކް ބޭނުންކުރުން",
      "tenant": "ޓެނަންޓް",
      "country": "ގައުމު",
      "running": "ހިންގަނީ",
      "latest": "އެންމެ ފަހުން ޕަބްލިޝްކުރި",
      "state": "ހާލަތު",
      "activatedOn": "ފެށި",
      "pendingSince": "މަޑުކުރަނީ",
      "searchLabel": "ޓެނަންޓުތައް ހޯދާ",
      "searchPlaceholder": "ނަން ނުވަތަ ސްލަގު",
      "emptyTitle": "އަދި ޓެނަންޓެއް ނެތް",
      "emptyDescription": "ބޭނުންކުރުން ބަލަނީ ޓެނަންޓަކުންނެވެ. ޓެނަންޓެއް ހަދައި، ގައުމެއްގެ ޕެކް ފައްޓަވާ.",
      "emptyFilteredTitle": "ގުޅޭ ޓެނަންޓެއް ނެތް",
      "emptyFilteredDescription": "ހުރިހާ ޓެނަންޓެއް ބެލުމަށް ހޯދުން ސާފުކުރައްވާ.",
      "loadFailed": "ޓެނަންޓް ލިސްޓު ލޯޑެއް ނުކުރެވުނު.",
      "rowUnavailable": "ނުކިޔުނު",
      "rowUnavailableHint": "މި ޓެނަންޓުގެ ސްކީމާ ނުހުޅުވުނު. ސަސްޕެންޑް ނުވަތަ އާކައިވްކޮށްފައިވާ ޓެނަންޓަކުން މިގޮތަށް ޖަވާބުދިނުމަކީ ފަރުމާކުރެވިފައިވާ ގޮތެވެ.",
      "noActivation": "ޕެކެއް ފައްޓާފައެއް ނެތް",
      "noActivationHint": "މި ޓެނަންޓް އަދި ޕެކަކުން ޓެކްހެއް ނުގުނައެވެ.",
      "states": {
        "current": "މިހާރުގެ",
        "currentHint": "ޕަބްލިޝްކުރި އެންމެ އައު ވަރޝަން ހިންގަނީ.",
        "pending": "އަޕްޑޭޓް މަޑުކުރަނީ",
        "pendingHint": "އައު ވަރޝަނެއް ޕަބްލިޝްކޮށްފައި، އަދި ބަލައިގަނެފައެއް ނެތް.",
        "overdue": "ލަސްވެފައި",
        "overdueHint": "އައު ވަރޝަނެއް ޕަބްލިޝްކުރިތާ {days} ދުވަހަށްވުރެ ގިނަވެއްޖެ، އަދިވެސް ބަލައިގަނެފައެއް ނެތް.",
        "failed": "ސައްހަކުރުން ފެއިލްވި",
        "failedHint": "ޓެނަންޓުގެ ސޭންޑްބޮކްސް ސައްހަކުރުން ފާހެއް ނުވި.",
        "unknown": "ނޭނގޭ",
        "unknownHint": "މި ގައުމަށް ޕަބްލިޝްކުރި ވަރޝަނެއް ރެކޯޑުގައި ނެތުމުން، އަޅާކިޔާނެ އެއްޗެއް ނެތެވެ."
      },
      "summary": {
        "tenants": "ޓެނަންޓުން",
        "current": "މިހާރުގެ",
        "pending": "މަޑުކުރަނީ",
        "overdue": "ލަސްވެފައި"
      },
      "scopeNote": "ގުނުންތަކުން ދައްކަނީ މި ޞަފުޙާގެ ޓެނަންޓުތައް، މުޅި ލިސްޓެއް ނޫން — ލިސްޓު ބެހިފައިވަނީ ކާސަރ ޕޭޖިންގުންނެވެ."
    },
    "fields": {
      "addressValidation": "އެޑްރެސް ސައްހަކުރުން",
      "amount": "އަދަދު",
      "baseKind": "ނަގާ ބިންގާ",
      "basis": "ބިންގާ",
      "boxNo": "ބޮކްސް",
      "channel": "ޗެނަލް",
      "channelClass": "ޗެނަލް ގިންތި",
      "code": "ކޯޑު",
      "componentKind": "ބައި",
      "country": "ގައުމު",
      "currency": "ފައިސާ",
      "defaultCurrency": "ޑިފޯލްޓް ފައިސާ",
      "defaultTimezone": "ޑިފޯލްޓް ޓައިމްޒޯން",
      "description": "ތަފްޞީލު",
      "direction": "މިސްރާބު",
      "docType": "ލިޔުމުގެ ބާވަތް",
      "dueRule": "ދައްކަންޖެހޭ ގަވާއިދު",
      "effectiveFrom": "ފެށޭ ތާރީޚް",
      "effectiveTo": "ނިމޭ ތާރީޚް",
      "einvoiceProvider": "އީ-އިންވޮއިސް ފޯރުކޮށްދޭ ފަރާތް",
      "einvoiceRequired": "އީ-އިންވޮއިސް ލާޒިމު",
      "filingCurrency": "ފައިލްކުރާ ފައިސާ",
      "formReference": "ފޯމު ރެފަރެންސް",
      "formula": "ފޯމިއުލާ",
      "formulaKind": "ފޯމިއުލާ",
      "frequency": "ތަކުރާރުވުން",
      "gapless": "ދޭތެރެ ނުކެނޑޭ",
      "geoCountryId": "ގުޅުވި ގައުމު",
      "geoLocalityId": "ގުޅުވި ރަށް",
      "geoSubdivisionId": "ގުޅުވި ސަރަހައްދު",
      "inputAccountCode": "އިންޕުޓް އެކައުންޓް",
      "isActive": "ހަރަކާތްތެރި",
      "isOverridable": "ބަދަލުކުރެވޭ",
      "isRecoverable": "އަނބުރާ ލިބޭ",
      "iso2": "އައި.އެސް.އޯ އަލްފާ-2",
      "iso3": "އައި.އެސް.އޯ އަލްފާ-3",
      "itemClass": "މުދަލުގެ ގިންތި",
      "jurisdictionCode": "ސަރަހައްދު",
      "kind": "ބާވަތް",
      "label": "ލޭބަލް",
      "level": "ލެވެލް",
      "localityLabel": "ރަށުގެ ލޭބަލް",
      "name": "ނަން",
      "note": "ނޯޓު",
      "numberFormat": "ނަމްބަރު ފޯމެޓް",
      "numberPadding": "ނަމްބަރު ދިގުމިން",
      "numberPrefix": "ނަމްބަރު ފެށުން",
      "numericCode": "އައި.އެސް.އޯ ނަމްބަރު",
      "officialName": "ރަސްމީ ނަން",
      "outputAccountCode": "އައުޓްޕުޓް އެކައުންޓް",
      "params": "ޕެރެމިޓަރުތައް",
      "parentCode": "މައި އެތި",
      "parentId": "މައި އެތި",
      "partyClass": "ފަރާތުގެ ގިންތި",
      "payableAccountCode": "ދައްކަންޖެހޭ އެކައުންޓް",
      "phoneCc": "ފޯނު ކޯޑު",
      "postalCode": "ޕޯސްޓަލް ކޯޑު",
      "predicate": "ޝަރުތު",
      "priceBasis": "އަގުގެ ބިންގާ",
      "priority": "އިސްކަން",
      "published": "ޕަބްލިޝްކުރި",
      "rate": "ރޭޓް",
      "regimeCode": "ރެޖީމް",
      "registrationHint": "ރަޖިސްޓަރީގެ އިރުޝާދު",
      "registrationPattern": "ރަޖިސްޓަރީގެ ނަމޫނާ",
      "retentionYears": "ބަހައްޓާ މުއްދަތު (އަހަރު)",
      "returnDefCode": "ރިޓަރން",
      "reviewDue": "މުރާޖައާ ކުރަންޖެހޭ",
      "reviewPeriodMonths": "މުރާޖައާ (މަސް)",
      "rounding": "ރައުންޑިންގ",
      "roundingMode": "ރައުންޑިންގ ގޮތް",
      "ruleId": "ގަވާއިދު",
      "sequenceNo": "ތަރުތީބު",
      "sign": "ނިޝާން",
      "sortOrder": "ތަރުތީބުކުރުން",
      "sourceCitation": "މަޞްދަރު",
      "statutory": "ގާނޫނީ",
      "statutoryLanguage": "ގާނޫނީ ބަސް",
      "subdivisionId": "ސަރަހައްދު",
      "subdivisionLabel": "ސަރަހައްދުގެ ލޭބަލް",
      "supplyType": "ސަޕްލައި ބާވަތް",
      "taxCode": "ޓެކްސް ކޯޑު",
      "timezone": "ޓައިމްޒޯން",
      "treatment": "ގެންގުޅޭ ގޮތް",
      "unitCurrency": "ޔުނިޓް ފައިސާ",
      "unitLabel": "ޔުނިޓް",
      "unregisteredTaxCode": "ރަޖިސްޓަރީ ނުވާ ކޯޑު",
      "valueKind": "އަގު",
      "version": "ވަރޝަން",
      "voidConsumesNumber": "ބާތިލުކުރުމުން ނަމްބަރު ހުސްވޭ"
    },
    "enums": {
      "jurisdictionLevel": {
        "country": "ގައުމު",
        "subdivision": "ސަރަހައްދު",
        "locality": "ރަށް"
      },
      "regimeKind": {
        "VAT": "ވެޓް / ޖީ.އެސް.ޓީ",
        "WHT": "ހިފެހެއްޓޭ ޓެކްސް",
        "LEVY": "ލެވީ",
        "CHARGE": "ސާވިސް ޗާޖު",
        "SALES_TAX": "ވިއްކުމުގެ ޓެކްސް"
      },
      "taxCodeKind": {
        "VAT": "ވެޓް / ޖީ.އެސް.ޓީ",
        "WHT": "ހިފެހެއްޓޭ ޓެކްސް",
        "LEVY": "ލެވީ",
        "CHARGE": "ސާވިސް ޗާޖު"
      },
      "treatment": {
        "standard": "އާންމު",
        "zero_rated": "ސުމެއް ރޭޓް",
        "exempt": "އިސްތިސްނާ",
        "reverse_charge": "ރިވަރސް ޗާޖު",
        "out_of_scope": "ދާއިރާއިން ބޭރު"
      },
      "basis": {
        "percent": "އިންސައްތަ",
        "per_unit": "ޔުނިޓަކަށް"
      },
      "rounding": {
        "line": "ސަތުރަކަށް",
        "document": "ލިޔުމަކަށް"
      },
      "roundingMode": {
        "half_up": "ބައި މައްޗަށް",
        "half_even": "ބައި ހަމަޔަށް"
      },
      "direction": {
        "input": "އިންޕުޓް",
        "output": "އައުޓްޕުޓް",
        "any": "ދެގޮތުންވެސް"
      },
      "supplyType": {
        "goods": "މުދާ",
        "services": "ޚިދުމަތް",
        "accommodation": "ތިބުން",
        "fnb": "ކާބޯތަކެތި",
        "digital": "ޑިޖިޓަލް",
        "transport": "ދަތުރުފަތުރު",
        "other": "އެހެނިހެން"
      },
      "partyClass": {
        "registered": "ރަޖިސްޓަރީވި",
        "unregistered": "ރަޖިސްޓަރީ ނުވާ",
        "export": "ބޭރުކުރުން",
        "government": "ސަރުކާރު",
        "exempt": "އިސްތިސްނާ",
        "non_resident": "ރަށްވެހި ނޫން"
      },
      "baseKind": {
        "net": "ސާފު އަދަދު",
        "net_plus_prior": "ސާފު އަދަދާއި ކުރީގެ ބައިތައް"
      },
      "posBasis": {
        "origin": "ފެށޭ ތަން",
        "destination": "ދާ ތަން",
        "hybrid": "ދެގޮތް"
      },
      "posFallback": {
        "origin": "ފެށޭ ތަނަށް ރުޖޫޢަވޭ",
        "out_of_scope": "ދާއިރާއިން ބޭރު"
      },
      "channelClass": {
        "default": "ޑިފޯލްޓް",
        "pos": "ވިއްކާ ތަން",
        "hospitality": "ފަތުރުވެރިކަން",
        "retail": "ރީޓެއިލް",
        "wholesale": "ހޯލްސޭލް",
        "b2b": "ވިޔަފާރިން ވިޔަފާރިއަށް",
        "portal": "ޕޯޓަލް",
        "web": "ވެބް"
      },
      "priceBasis": {
        "inclusive": "ޓެކްސް ހިމެނޭ",
        "exclusive": "ޓެކްސް ނުހިމެނޭ"
      },
      "frequency": {
        "monthly": "މަހަކު",
        "quarterly": "ކުއާޓަރަކު",
        "biannual": "އަހަރަކު ދެފަހަރު",
        "annual": "އަހަރަކު"
      },
      "valueKind": {
        "base": "ބިންގާ",
        "tax": "ޓެކްސް",
        "computed": "ގުނާފައި"
      },
      "componentKind": {
        "earning": "ލިބޭ",
        "deduction": "އުނިކުރެވޭ",
        "employer_cost": "ވަޒީފާދޭ ފަރާތުގެ ޚަރަދު",
        "leave_minimum": "އެންމެ މަދު ޗުއްޓީ",
        "threshold": "ހައްދު"
      },
      "formulaKind": {
        "fixed": "ސާބިތު",
        "percent": "އިންސައްތަ",
        "slab": "ދަރަޖަ",
        "per_unit": "ޔުނިޓަކަށް"
      },
      "addressValidation": {
        "enforce": "ލާޒިމު",
        "warn": "އިންޒާރު",
        "allow": "ހުއްދަ"
      },
      "subdivisionKind": {
        "state": "ސްޓޭޓް",
        "province": "ޕްރޮވިންސް",
        "atoll": "އަތޮޅު",
        "region": "ސަރަހައްދު",
        "emirate": "އިމާރާތް",
        "district": "ޑިސްޓްރިކްޓް",
        "county": "ކައުންޓީ",
        "prefecture": "ޕްރިފެކްޗަރ",
        "territory": "ސަރަޙައްދު",
        "other": "އެހެނިހެން"
      },
      "localityKind": {
        "city": "ސިޓީ",
        "town": "ޓައުން",
        "island": "ރަށް",
        "zone": "ޒޯން",
        "free_zone": "ފްރީ ޒޯން",
        "district": "ޑިސްޓްރިކްޓް",
        "village": "އަވަށް",
        "other": "އެހެނިހެން"
      }
    },
    "tenantTaxPacks": {
      "title": "{name} ގެ ޓެކްސް ޕެކްތައް",
      "description": "މި ޓެނަންޓް ފައްޓާފައިވާ ގައުމުތަކުގެ ޕެކްތަކާއި، އޮޕަރޭޓަރަށް ޕެކެއް ފެށޭނެ ގޮތެވެ.",
      "backToAdoption": "ބޭނުންކުރުމަށް އަނބުރާ",
      "loadFailed": "މި ޓެނަންޓް ފައްޓާފައިވާ ޓެކްސް ޕެކްތައް ލޯޑެއް ނުކުރެވުނު.",
      "tenantLoadFailed": "މި ޓެނަންޓް ލޯޑެއް ނުކުރެވުނު.",
      "tableLabel": "މި ޓެނަންޓް ފައްޓާފައިވާ ޓެކްސް ޕެކްތައް",
      "emptyTitle": "އަދި ޕެކެއް ފައްޓާފައެއް ނެތް",
      "emptyDescription": "މި ޓެނަންޓަށް ދިރޭ ޓެކްސް ހިސާބުކުރުމެއް ދިނުމަށް ގައުމެއްގެ ޕަބްލިޝްކޮށްފައިވާ ޕެކެއް ފައްޓަވާ.",
      "activate": "ޕެކެއް ފައްޓާ",
      "writeNote": "ޕެކެއް ފެށުމަށް އޯނަރ ނުވަތަ ސަޕޯޓް ރޯލު ބޭނުންވެއެވެ.",
      "manageLink": "{name} ގެ ޓެކްސް ޕެކްތައް މެނޭޖުކުރައްވާ"
    },
    "tenantActivate": {
      "title": "ޓެކްސް ޕެކެއް ފައްޓާ",
      "description": "ގައުމުގެ އެންމެ ފަހުން ޕަބްލިޝްކުރި ޕެކް މި ޓެނަންޓުގެ ސްކީމާއަށް ކޮޕީކުރެއެވެ.",
      "countryLabel": "ގައުމު",
      "countryHint": "ޓެނަންޓް ރަޖިސްޓަރީކޮށްފައިވާ ގައުމަށް ޑިފޯލްޓްކުރެއެވެ.",
      "countryPlaceholder": "ޓެނަންޓް ރަޖިސްޓަރީކޮށްފައިވާ ގައުމު",
      "effectiveFromLabel": "ފެށޭ ތާރީޚް",
      "effectiveFromHint": "މިއަދަށް ޑިފޯލްޓްކުރެއެވެ.",
      "submit": "ފައްޓާ",
      "failed": "ޕެކް ނުފެއްޓުނު.",
      "success": "ޕެކް ފެށިއްޖެ."
    }
  }
}
